'use strict';
import stringSimilarity from 'string-similarity';

const clearSvg = require('../../images/clear.svg');
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('docketDesktopController', function (docketService, orderService, resourceService, userService, batchService, xeroService, addressBookService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q, $location) {
    mixpanel.track("Opened Dockets Desktop");

    $scope.myDocketbook = ($stateParams.myDocketbook == true)
    if ($scope.myDocketbook) {
      mixpanel.track("Opened Dockets Desktop - My Docketbook");
    }

    $scope.clearSvgImagePath = clearSvg;
    /***************************/
    /***** Setup Variables *****/
    /***************************/
    $scope.moment = moment;
    $scope.listItems = [];
    $scope.itemEdit = null;
    $scope.listView = 'dockets';
    $scope.detailView = 'dockets';
    $scope.listFull = true;
    $scope.xeroContacts = [];
    $scope.customTemplate = [
      {
        name: 'Last 12 Months',
        dateStart: moment().subtract(12, 'months').toDate(),
        dateEnd: moment().toDate(),
      }
    ]

    $scope.rejectReason = { text: '' };
    $scope.rejectingDockets = [];
    $scope.rejectingDocket = null;
    $scope.rejectLoading = false;
    $scope.bulkReject = false;

    var statusFilterOptions = ['draft', 'sent', 'accepted', 'rejected'];
    var customerSignatureOptions = ['signed', 'unsigned'];
    var invoicedStatusFilterOptions = ['invoiced', 'uninvoiced'];
    var filedOptions = ['filed', 'unfiled']

    if ($stateParams.viewMode && $stateParams.viewMode == 'filing') {
      $scope.listView = 'filing';
      $scope.detailView = 'filing';
    } else if ($stateParams.viewMode && $stateParams.viewMode == 'batch') {
      $scope.listView = 'batch';
      $scope.detailView = 'batch';
    } else {
      $scope.listView = 'dockets';
      $scope.detailView = 'dockets';
    }

    $scope.fullApiPath = DOCKETBOOK_API_URL + "/" + $scope.urlVersion;

    $scope.detailOpen = false;
    $scope.showFilters = false;
    $scope.preventReloadWithFilters = true;
    $scope.selected = [];
    $scope.assignDocket = {};
    $scope.assignDocket.selected = [];

    // Last geolocation
    $scope.lastGeolocation = {};
    $scope.lastGeolocationCheck = moment();

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    // Filters initial
    $scope.subFilters = {};
    $scope.filters = {};
    $scope.filters.customerSignatureOptions = { allView: true, all: true, signed: true, unsigned: true, display: false };
    $scope.filters.filedOptions = { all: true, filed: false, unfiled: false }
    $scope.filters.otherParty = "All";
    $scope.filters.statusTab = "All";
    $scope.filters.status = "All";
    $scope.filters.invoicedStatus = "All";
    $scope.filters.fileStatusTab = 'all';
    $scope.filters.batchStatusTab = 'all';
    $scope.filters.organisation = "All";
    $scope.filters.startDate = moment().subtract(7, 'days').toDate(); //startFromDate
    $scope.filters.endDate = moment().toDate(); //endToDate
    $scope.dateFilterModel = { dateStart: $scope.filters.startDate, dateEnd: $scope.filters.endDate, showTemplate: true };
    $scope.filters.customerGroup = null;
    $scope.filters.supplierGroup = null;
    $scope.filters.author = null;
    $scope.filters.statusOptions = { allView: true, all: true, draft: true, sent: true, accepted: true, rejected: true };
    $scope.filters.invoicedStatusOptions = { allView: true, all: true, invoiced: true, uninvoiced: true };
    $scope.filterHeading = "";
    $scope.activeFilters = 0;
    $scope.filters.organisationId = $scope.currentOrg ? $scope.currentOrg.id : null;
    $scope.filters.groupId = $scope.currentOrgGroup ? $scope.currentOrgGroup.id : null;
    $scope.filters.customerDisplayName = null;
    $scope.filters.supplierDisplayName = null;
    $scope.filters.customerSignatureName = null;
    $scope.filters.acceptedBy = null;
    $scope.filters.custom =
      $scope.currentOrg && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.customColumns
        ? $scope.currentOrg.features.dockets.customColumns.map(fieldName => ({ fieldName, prettyName: fieldName.match(/[A-Z][a-z,1-9]+/g).join(' '), display: false, value: '' }))
        : []


    $scope.goToBulkDocketImport = function() {
      window.location.href = `/app/org/${$scope.currentOrg.id}/group/${$scope.currentOrgGroup.id}/dockets/bulkimport`
    }

    $scope.isDisabledDate = function (date) {
      //if ($scope.currentOrg.plan == null || $scope.currentOrg.planFeatures == null || !$scope.currentOrg.planFeatures.docketsHistoricalDateLimit) { return true; }

      if ($scope.currentOrg == null || $scope.currentOrg.planFeatures.docketsHistoricalDateLimit == -1) {
        return false
      }

      var diff = (new Date() - date) / (1000 * 60 * 60 * 24)
      return diff > $scope.currentOrg.planFeatures.docketsHistoricalDateLimit
    }

    $scope.$watch('dateFilterModel.dateStart', function (before, after) {
      if ($scope.dateFilterModel.dateStart) {
        if ($scope.currentOrg && $scope.currentOrg.planFeatures.docketsHistoricalDateLimit != -1) {
          if (moment().diff(moment($scope.dateFilterModel.dateStart), 'days') > $scope.currentOrg.planFeatures.docketsHistoricalDateLimit) {
            $scope.dateFilterModel.dateStart = moment().add(-$scope.currentOrg.planFeatures.docketsHistoricalDateLimit, 'days').toDate()

            if (moment($scope.dateFilterModel.dateEnd).isBefore($scope.dateFilterModel.dateStart)) {
              $scope.dateFilterModel.dateEnd = moment($scope.dateFilterModel.dateStart).toDate()
            }

            swal({
              title: "Oops!",
              text: `The ${$scope.currentOrg.planFeatures.name == null ? 'free' : $scope.currentOrg.planFeatures.name} plan only allows docket history up to ${$scope.currentOrg.planFeatures.docketsHistoricalDateLimit} days.  The search value has been updated.`,
              type: "warning",
              confirmButtonText: "Ok, got it."
            });
          }
        }
        $scope.filters.startDate = $scope.dateFilterModel.dateStart;
      }
      if (!$scope.preventReloadWithFilters) {
        if (moment(after).diff(moment(before), 'days') != 0) {
          $scope.filtersChanged('date selector');
        }
      }
    }, true);

    $scope.$watch('dateFilterModel.dateEnd', function (before, after) {
      if ($scope.dateFilterModel.dateEnd) {
        $scope.filters.endDate = $scope.dateFilterModel.dateEnd;
      }
      if (!$scope.preventReloadWithFilters) {
        if (moment(after).diff(moment(before), 'days') != 0) {
          $scope.filtersChanged('date selector');
        }
      }
    }, true);

    // New list query pagination
    $scope.filters.query = {
      limit: 30,
      page: 1,
      order: 'docketNumber'
    };

    $scope.reportButtonClick = function (mdOpenMenu, evt) {
      if ($scope.currentOrg.planFeatures.docketsReports) {
        $scope.openMenu(mdOpenMenu, evt)
      } else {
        /*if ( $scope.currentOrg ) {
          $state.go('main.groupExportDockets', {orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id});
        } else {
          $state.go('main.exportDockets');
        }*/
        $scope.showUpgradePlanModal(null, 'docketsReports', 'from dockets page - report button click')
      }
    }

    var loadSavedFilters = function () {
      var storedFilters = {};
      if (sessionStorage.getItem('filters')) {
        storedFilters = JSON.parse(sessionStorage.getItem('filters'));
      }
      var lastDocketsFilters = {};
      if (sessionStorage.getItem('docketsLastFilters')) {
        lastDocketsFilters = JSON.parse(sessionStorage.getItem('docketsLastFilters'));
      }
      if ($scope.listView == 'dockets') {
        if (storedFilters) {
          if (storedFilters.order && storedFilters.order.id) {
            $scope.filters.order = storedFilters.order;
          }
          // if url params has order - override stored filter order
          if ($stateParams.orderId != null) {
            $scope.filters.order = { id: $stateParams.orderId };
            if ($stateParams.orderNumber != null) {
              $scope.filters.order.orderNumber = $stateParams.orderNumber;
            }
          }
          if (storedFilters.job && storedFilters.job.id) {
            $scope.filters.job = storedFilters.job;
          }
          // if url params has job - override stored filter job
          if ($stateParams.jobId != null) {
            $scope.filters.job = { id: $stateParams.jobId };
            if ($stateParams.jobNumber != null) {
              $scope.filters.job.jobNumber = $stateParams.jobNumber;
            }
          }
          if (storedFilters.statusOptions) {
            for (var i = 0; i < statusFilterOptions.length; i++) {
              if (storedFilters.statusOptions[statusFilterOptions[i]] == true) {
                $scope.filters.statusOptions[statusFilterOptions[i]] = true;
              } else {
                $scope.filters.statusOptions[statusFilterOptions[i]] = false;
              }
            }
            if (storedFilters.statusOptions.all == true) {
              $scope.filters.statusOptions.all = true;
              for (var i = 0; i < statusFilterOptions.length; i++) {
                $scope.filters.statusOptions[statusFilterOptions[i]] = true;
              }
            } else {
              $scope.filters.statusOptions.all = false;
            }
          }
          if (storedFilters.customerSignatureOptions) {
            var displayOption = true;
            if (storedFilters.customerSignatureOptions.display == false) {
              displayOption = false;
            }
            for (var i = 0; i < customerSignatureOptions.length; i++) {
              if (storedFilters.customerSignatureOptions[customerSignatureOptions[i]] == true) {
                $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
              } else {
                $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = false;
              }
            }
            if (storedFilters.customerSignatureOptions.all == true) {
              $scope.filters.customerSignatureOptions.all = true;
              for (var i = 0; i < customerSignatureOptions.length; i++) {
                $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
              }
            } else {
              $scope.filters.customerSignatureOptions.all = false;
            }
            $scope.filters.customerSignatureOptions.display = displayOption;
          }
          if (storedFilters.filedOptions) {
            $scope.filters.filedOptions = Object.assign({}, storedFilters.filedOptions)
          }
          if (storedFilters.invoicedStatusOptions) {
            for (var i = 0; i < invoicedStatusFilterOptions.length; i++) {
              if (storedFilters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] == true) {
                $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
              } else {
                $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = false;
              }
            }
            if (storedFilters.invoicedStatusOptions.all == true) {
              $scope.filters.invoicedStatusOptions.all = true;
              for (var i = 0; i < invoicedStatusFilterOptions.length; i++) {
                $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
              }
            } else {
              $scope.filters.invoicedStatusOptions.all = false;
            }
          }
          // if state params status is set - uisref status has been used and overrite status statusOptions
          if ($stateParams.status != undefined) {
            $scope.filters.statusOptions.all = false;
            for (var i = 0; i < statusFilterOptions.length; i++) {
              $scope.filters.statusOptions[statusFilterOptions[i]] = false;
            }
            $scope.filters.statusOptions[$stateParams.status] = true;
          }
          if (storedFilters.customerContact != null) {
            $scope.filters.customerContact = storedFilters.customerContact;
          }
          if (storedFilters.supplierContact != null) {
            $scope.filters.supplierContact = storedFilters.supplierContact;
          }
          if (storedFilters.customerDisplayName != null) {
            $scope.filters.customerDisplayName = storedFilters.customerDisplayName;
          }
          if (storedFilters.supplierDisplayName != null) {
            $scope.filters.supplierDisplayName = storedFilters.supplierDisplayName;
          }
          if (storedFilters.customerSignatureName != null) {
            $scope.filters.customerSignatureName = storedFilters.customerSignatureName;
          }
          if (storedFilters.custom != null) {
            $scope.filters.custom = storedFilters.custom;
          }
          if (storedFilters.acceptedBy != null) {
            $scope.filters.acceptedBy = storedFilters.acceptedBy;
          }
          if (storedFilters.startDate != null) {
            $scope.filters.startDate = moment(storedFilters.startDate).toDate();
            $scope.dateFilterModel.dateStart = $scope.filters.startDate;
          }
          if (storedFilters.endDate != null) {
            $scope.filters.endDate = moment(storedFilters.endDate).toDate();
            $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
          }
          if (storedFilters.docketNumber != null) {
            $scope.filters.docketNumber = storedFilters.docketNumber;
          } else if (lastDocketsFilters.docketNumber) {
            $scope.filters.docketNumber = lastDocketsFilters.docketNumber;
          }
          if (storedFilters.customerRefNo != null) {
            $scope.filters.customerRefNo = storedFilters.customerRefNo;
          } else if (lastDocketsFilters.customerRefNo) {
            $scope.filters.customerRefNo = lastDocketsFilters.customerRefNo;
          }
          if (storedFilters.supplierRefNo != null) {
            $scope.filters.supplierRefNo = storedFilters.supplierRefNo;
          } else if (lastDocketsFilters.supplierRefNo) {
            $scope.filters.supplierRefNo = lastDocketsFilters.supplierRefNo;
          }
          if (storedFilters.author != null) {
            $scope.filters.author = storedFilters.author;
          } else if (lastDocketsFilters.author) {
            $scope.filters.author = lastDocketsFilters.author;
          }
          if (storedFilters.reloadRequired) {
            $scope.filters.reloadRequired = storedFilters.reloadRequired;
          }
        }
      } else if ($scope.listView == 'filing') {
        if (storedFilters) {
          if (storedFilters.orderId != null) {
            $scope.filters.order = { id: storedFilters.orderId };
            if (storedFilters.orderNumber != null) {
              $scope.filters.order.orderNumber = storedFilters.orderNumber;
            }
          }
          if (storedFilters.jobId != null) {
            $scope.filters.job = { id: storedFilters.jobId };
            if (storedFilters.jobNumber != null) {
              $scope.filters.job.jobNumber = storedFilters.jobNumber;
            }
          }
          if (storedFilters.customerContact != null) {
            $scope.filters.customerContact = storedFilters.customerContact;
          }
          if (storedFilters.supplierContact != null) {
            $scope.filters.supplierContact = storedFilters.supplierContact;
          }
          if (storedFilters.docketNumber != null) {
            $scope.filters.docketNumber = storedFilters.docketNumber;
          }
          if (storedFilters.customerRefNo != null) {
            $scope.filters.customerRefNo = storedFilters.customerRefNo;
          }
          if (storedFilters.supplierRefNo != null) {
            $scope.filters.supplierRefNo = storedFilters.supplierRefNo;
          }
          if (storedFilters.author != null) {
            $scope.filters.author = storedFilters.author;
          }
          if (storedFilters.startDate != null) {
            $scope.filters.startDate = moment(storedFilters.startDate).toDate();
            $scope.dateFilterModel.dateStart = $scope.filters.startDate;
          }
          if (storedFilters.endDate != null) {
            $scope.filters.endDate = moment(storedFilters.endDate).toDate();
            $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
          }
        }
      } else if ($scope.listView == 'batch') {
        if (storedFilters) {
          if (storedFilters.orderId != null) {
            $scope.filters.order = { id: storedFilters.orderId };
            if (storedFilters.orderNumber != null) {
              $scope.filters.order.orderNumber = storedFilters.orderNumber;
            }
          }
          if (storedFilters.jobId != null) {
            $scope.filters.job = { id: storedFilters.jobId };
            if (storedFilters.jobNumber != null) {
              $scope.filters.job.jobNumber = storedFilters.jobNumber;
            }
          }
          if (storedFilters.customerContact != null) {
            $scope.filters.customerContact = storedFilters.customerContact;
          }
          if (storedFilters.supplierContact != null) {
            $scope.filters.supplierContact = storedFilters.supplierContact;
          }
          if (storedFilters.startDate != null) {
            $scope.filters.startDate = moment(storedFilters.startDate).toDate();
            $scope.dateFilterModel.dateStart = $scope.filters.startDate;
          }
          if (storedFilters.endDate != null) {
            $scope.filters.endDate = moment(storedFilters.endDate).toDate();
            $scope.dateFilterModel.dateEnd = $scope.filters.endDate;
          }
        }
      }
      // load in most recent query params
      if (sessionStorage.getItem('docketsQuery')) {
        var queryStored = JSON.parse(sessionStorage.getItem('docketsQuery'));
        if (queryStored != null) {
          if (queryStored.limit) {
            $scope.filters.query.limit = queryStored.limit;
          }
          if (queryStored.page) {
            $scope.filters.query.page = queryStored.page;
          }
          if (queryStored.order) {
            $scope.filters.query.order = queryStored.order;
          }
        }
      }
      sessionStorage.setItem('filters', JSON.stringify($scope.filters));
    }

    loadSavedFilters();

    $scope.promise = null;

    $scope.splitListFunc = new splitListInterface($scope, $stateParams);

    $scope.setListView = function (view) {
      $scope.listView = view;

      if (view == 'filing') {
        $scope.loadDocketFilingList();
      } else if (view == 'dockets') {
        $scope.loadDocketsList();
      } else if (view == 'batch') {
        $scope.loadBatchesList();
      }
    }

    /*** New Filters Helpers ***/

    $scope.prettifyFilterStatusPreview = function () {
      var output = "";

      if ($scope.filters.statusOptions.all) {
        return "All";
      }

      var soFar = 0;
      if ($scope.filters.statusOptions.draft) {
        soFar += 1;
        output += "Draft";
      }
      if ($scope.filters.statusOptions.sent) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Sent";
      }
      if ($scope.filters.statusOptions.accepted) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Accepted";
      }
      if ($scope.filters.statusOptions.rejected) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Rejected";
      }
      if (soFar == 0) {
        output += "None selected";
      }
      return output;
    }

    $scope.prettifyFilterCustomerSignaturePreview = function () {
      var output = "";

      if ($scope.filters.customerSignatureOptions.all) {
        return "All";
      }

      var soFar = 0;
      if ($scope.filters.customerSignatureOptions.signed) {
        soFar += 1;
        output += "Signed";
      }
      if ($scope.filters.customerSignatureOptions.unsigned) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Unsigned";
      }
      if (soFar == 0) {
        output += "None selected";
      }
      return output;
    }

    $scope.prettifyFilterFiledPreview = function () {
      return $scope.filters.filedOptions.all
        ? "All"
        : $scope.filters.filedOptions.filed
          ? "Filed"
          : $scope.filters.filedOptions.unfiled
            ? "Unfiled"
            : "None selected";
    }

    $scope.statusFilterCheckboxChanged = function () {
      $scope.statusFiltersChanged();
    }

    $scope.statusFiltersChanged = function () {
      var selectedCount = 0;
      for (var option in statusFilterOptions) {
        if ($scope.filters.statusOptions[statusFilterOptions[option]]) {
          selectedCount += 1;
        }
      }
      if (selectedCount == statusFilterOptions.length) {
        $scope.filters.statusOptions.all = true;
      } else {
        $scope.filters.statusOptions.all = false;
      }
      if (!$scope.preventReloadWithFilters) {
        $scope.filtersChanged('status options');
      }
    }

    $scope.customerSignatureFiltersChanged = function () {
      var selectedCount = 0;
      for (var option in customerSignatureOptions) {
        if ($scope.filters.customerSignatureOptions[customerSignatureOptions[option]]) {
          selectedCount += 1;
        }
      }
      if (selectedCount == customerSignatureOptions.length) {
        $scope.filters.customerSignatureOptions.all = true;
      } else {
        $scope.filters.customerSignatureOptions.all = false;
      }
      if (!$scope.preventReloadWithFilters) {
        $scope.filtersChanged('customerSignature options');
      }
    }

    $scope.filedFiltersChanged = function () {
      var selectedCount = 0;
      for (var option in filedOptions) {
        if ($scope.filters.filedOptions[filedOptions[option]]) {
          selectedCount += 1;
        }
      }
      if (selectedCount == filedOptions.length) {
        $scope.filters.filedOptions.all = true;
      } else {
        $scope.filters.filedOptions.all = false;
      }
      if (!$scope.preventReloadWithFilters) {
        $scope.filtersChanged('filed options');
      }
    }

    $scope.swapStatusFilter = function (option) {
      if (option == 'all' && $scope.filters.statusOptions.all == false) {
        for (var i in statusFilterOptions) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = true;
        }
        $scope.filters.statusOptions.allView = true;
        $scope.filters.statusOptions.all = true;
      } else if (option == 'all' && $scope.filters.statusOptions.all == true) {
        for (var i in statusFilterOptions) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        }
        $scope.filters.statusOptions.allView = false;
        $scope.filters.statusOptions.all = false;
      }
      $scope.statusFiltersChanged();
    }

    $scope.swapCustomerSignatureFilter = function (option) {
      if (option == 'all' && $scope.filters.customerSignatureOptions.all == false) {
        for (var i in customerSignatureOptions) {
          $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
        }
        $scope.filters.customerSignatureOptions.allView = true;
        $scope.filters.customerSignatureOptions.all = true;
      } else if (option == 'all' && $scope.filters.customerSignatureOptions.all == true) {
        for (var i in customerSignatureOptions) {
          $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = false;
        }
        $scope.filters.customerSignatureOptions.allView = false;
        $scope.filters.customerSignatureOptions.all = false;
      }
      $scope.customerSignatureFiltersChanged();
    }

    $scope.swapFiledFilter = function (option) {
      if (option == 'all' && $scope.filters.filedOptions.all == false) {
        for (var i in filedOptions) {
          $scope.filters.filedOptions[filedOptions[i]] = true;
        }
        $scope.filters.filedOptions.allView = true;
        $scope.filters.filedOptions.all = true;
      } else if (option == 'all' && $scope.filters.filedOptions.all == true) {
        for (var i in filedOptions) {
          $scope.filters.filedOptions[filedOptions[i]] = false;
        }
        $scope.filters.filedOptions.allView = false;
        $scope.filters.filedOptions.all = false;
      }
      $scope.filedFiltersChanged();
    }

    $scope.setOnlyFilter = function (option) {
      $scope.filters.statusOptions.all = false;
      for (var i in statusFilterOptions) {
        if (statusFilterOptions[i] != option) {
          $scope.filters.statusOptions[statusFilterOptions[i]] = false;
        } else {
          $scope.filters.statusOptions[statusFilterOptions[i]] = true;
        }
      }
      $scope.statusFiltersChanged();
    }

    $scope.setCustomerSignatureOnlyFilter = function (option) {
      $scope.filters.customerSignatureOptions.all = false;
      for (var i in customerSignatureOptions) {
        if (customerSignatureOptions[i] != option) {
          $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = false;
        } else {
          $scope.filters.customerSignatureOptions[customerSignatureOptions[i]] = true;
        }
      }
      $scope.customerSignatureFiltersChanged();
    }

    $scope.setFiledOnlyFilter = function (option) {
      $scope.filters.filedOptions.all = false;
      for (var i in filedOptions) {
        if (filedOptions[i] != option) {
          $scope.filters.filedOptions[filedOptions[i]] = false;
        } else {
          $scope.filters.filedOptions[filedOptions[i]] = true;
        }
      }
      $scope.filedFiltersChanged();
    }

    /*** New Invoiced/Uninvoiced Filters Helpers ***/

    $scope.prettifyInvoicedFilterStatusPreview = function () {
      var output = "";

      if ($scope.filters.invoicedStatusOptions.all) {
        return "All";
      }

      var soFar = 0;
      if ($scope.filters.invoicedStatusOptions.invoiced) {
        soFar += 1;
        output += "Invoiced";
      }
      if ($scope.filters.invoicedStatusOptions.uninvoiced) {
        if (soFar > 0) {
          output += ", ";
        }
        soFar += 1;
        output += "Uninvoiced";
      }
      if (soFar == 0) {
        output += "None selected";
      }
      return output;
    }

    $scope.invoicedStatusFilterCheckboxChanged = function () {
      $scope.invoicedStatusFiltersChanged();
    }

    $scope.customerSignatureFilterCheckboxChanged = function () {
      $scope.customerSignatureFiltersChanged();
    }

    $scope.hideCustomerSignatureFilter = function () {
      $scope.filters.customerSignatureOptions.display = false;
      $scope.swapCustomerSignatureFilter('all');
      $scope.filtersChanged('customer signature filter hidden');
    }

    $scope.filedFilterCheckboxChanged = function () {
      $scope.filedFiltersChanged();
    }

    $scope.hideFiledFilter = function () {
      $scope.filters.filedOptions.display = false;
      $scope.swapFiledFilter('all')
      $scope.filtersChanged('filed filter hidden')
    }

    $scope.invoicedStatusFiltersChanged = function () {
      var selectedCount = 0;
      for (var option in invoicedStatusFilterOptions) {
        if ($scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[option]]) {
          selectedCount += 1;
        }
      }
      if (selectedCount == invoicedStatusFilterOptions.length) {
        $scope.filters.invoicedStatusOptions.all = true;
      } else {
        $scope.filters.invoicedStatusOptions.all = false;
      }
      if (!$scope.preventReloadWithFilters) {
        $scope.filtersChanged('invoiced status options');
      }
    };

    $scope.swapInvoicedStatusFilter = function (option) {
      if (option == 'all' && $scope.filters.invoicedStatusOptions.all == false) {
        for (var i in invoicedStatusFilterOptions) {
          $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
        }
        $scope.filters.invoicedStatusOptions.allView = true;
        $scope.filters.invoicedStatusOptions.all = true;
      } else if (option == 'all' && $scope.filters.invoicedStatusOptions.all == true) {
        for (var i in invoicedStatusFilterOptions) {
          $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = false;
        }
        $scope.filters.invoicedStatusOptions.allView = false;
        $scope.filters.invoicedStatusOptions.all = false;
      }
      $scope.invoicedStatusFiltersChanged();
    }

    $scope.setOnlyInvoicedFilter = function (option) {
      $scope.filters.invoicedStatusOptions.all = false;
      for (var i in invoicedStatusFilterOptions) {
        if (invoicedStatusFilterOptions[i] != option) {
          $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = false;
        } else {
          $scope.filters.invoicedStatusOptions[invoicedStatusFilterOptions[i]] = true;
        }
      }
      $scope.invoicedStatusFiltersChanged();
    }

    $scope.hideInvoicedFilter = function () {
      $scope.filters.invoicedStatusOptions.display = false;
      $scope.swapInvoicedStatusFilter('all')
      $scope.invoicedStatusFiltersChanged('invoiced filter hidden')
    }

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    /***************************************/
    /***** Docket Detail View Controls *****/
    /***************************************/

    $scope.openDocketDesktop = function (docket, editing, tab) {
      var currentDocket = $scope.getCurrentDocketFromParent();
      var docketId = docket;
      if (docketId.id != null) {
        docketId = docketId.id;
      }
      if (!currentDocket) {
        if ($scope.currentOrg) {
          $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
        } else {
          $state.go('main.docketDetail', { docketId: docketId });
        }
        //openDocket(docket, editing, tab);
        return;
      } else if (currentDocket.id == docketId) {
        return;
      }
      var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'getDiffedDocket', function (diff, count) {
        if (count > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveDocket(currentDocket, function () {
                if ($scope.currentOrg) {
                  $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
                } else {
                  $state.go('main.docketDetail', { docketId: docketId });
                }
              });
            } else if (actionSelected == 'dontSave') {
              if ($scope.currentOrg) {
                $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
              } else {
                $state.go('main.docketDetail', { docketId: docketId });
              }
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          if ($scope.currentOrg) {
            $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketId, editing: editing });
          } else {
            $state.go('main.docketDetail', { docketId: docketId });
          }
        }
      });
    }

    var openDocket = function (docket, editing, tab, afterFilingAccept) {
      $scope.currentDocket = docket;
      $scope.afterFilingAccept = afterFilingAccept;
      $scope.docketLoadingError = null;
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.listFull = false;
      $scope.detailView = 'dockets';
      $scope.prepareForDocketFromParent(null, docket);
      docketService.getDocket(docket, true, function (fullDocket) {
        $scope.lastCleanDocket = angular.copy(fullDocket);
        $scope.getDocketTotalTime(fullDocket);
        $scope.loadDocketFromParent(fullDocket, tab, editing);
        $scope.updateSelectedDocketFromParent(fullDocket);
      }, function (err) {
        $scope.docketLoadingError = "Error Getting Docket";
        $scope.docketLoadingErrorFull = err;
      });
    }

    $scope.closeDocketDesktop = function () {
      var currentDocket = $scope.getCurrentDocketFromParent();
      if (!currentDocket || currentDocket.id == null) {
        if ($scope.currentOrg) {
          $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        } else {
          $state.go('main.dockets');
        }
        return;
      }
      var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'resources', function (diff, count) {
        if (count > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveDocket(currentDocket, function () {
                if ($scope.currentOrg) {
                  $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                } else {
                  $state.go('main.dockets');
                }
              });
            } else if (actionSelected == 'dontSave') {
              if ($scope.currentOrg) {
                $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              } else {
                $state.go('main.dockets');
              }
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          if ($scope.currentOrg) {
            $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          } else {
            $state.go('main.dockets');
          }
        }
      });
    }

    var closeDocket = function () {
      $scope.splitListFunc.slideTableListDetailClosed();
      $scope.afterFilingAccept = false;
      $scope.listFull = true;
      $scope.clearDocketFromParent();
    }

    $scope.closeDocket = $scope.closeDocketDesktop;

    $scope.newDocket = function (fromType, fromId, forOperator) {
      mixpanel.track("Clicked Create New Docket");

      var currentDocket = $scope.getCurrentDocketFromParent();
      if (!currentDocket) {
        $scope.selectAuthorAndCreateDocket(forOperator);
        return;
      }

      var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'resources', function (diff, count) {
        if (count > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveDocket(currentDocket, function () {
                $scope.selectAuthorAndCreateDocket(forOperator);
                return;
              });
            } else if (actionSelected == 'dontSave') {
              $scope.selectAuthorAndCreateDocket(forOperator);
              return;
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          $scope.selectAuthorAndCreateDocket(forOperator);
          return;
        }
      });
    }

    $scope.selectAuthorAndCreateDocket = function (forOperator) {
      if (!forOperator) {
        $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: 'new', author: null, authorName: null, fromOrder: null, fromJob: null });
        return;
      } else {
        $scope.desktopPeopleSelectFromParent([], function (selected) {
          if (selected && selected[0]) {
            // TODO: ADD AUTHOR TO ROUTE
            $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: 'new', author: selected[0].id, authorName: selected[0].name.full, fromOrder: null, fromJob: null });
            return;
          } else {
            return;
          }
        });
      }
    }

    var newDocket = function (fromType, fromId) {
      $scope.listView = 'dockets';
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.afterFilingAccept = false;
      $scope.listFull = false;
      $scope.docketLoadingError = null;
      $scope.docketLoadingErrorFull = null;
      $scope.newDocketFromParent(fromType, fromId, function (newDocket) {
        if (newDocket.id != null) {
          $scope.openDocketDesktop(newDocket, true, 0);
          $scope.loadDocketsList();
        } else {
          $scope.openNewDocketFromParent(newDocket);
        }
      });
    }

    var newDocketForAuthor = function (author, authorName, fromType, fromId) {
      $scope.listView = 'dockets';
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.afterFilingAccept = false;
      $scope.listFull = false;
      $scope.docketLoadingError = null;
      $scope.docketLoadingErrorFull = null;
      $scope.newDocketWithAuthorFromParent(author, authorName, fromType, fromId, function (newDocket) {
        if (newDocket.id != null) {
          $scope.openDocketDesktop(newDocket, true, 0);
          $scope.loadDocketsList();
        } else {
          $scope.openNewDocketFromParent(newDocket);
        }
      });
    }

    $scope.saveDocket = function (docket, cb) {
      mixpanel.track("Clicked Save Docket");
      var newDocket = false;
      if (docket.id == null) {
        newDocket = true;
      }
      docket.loading = true;
      docket.loadingType = "saving";
      // get diff of docket before saving
      if (!newDocket) {
        var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, docket, 'resources', function (diff, count) {
          if (count > 0) {
            docketService.saveDocket(diff, function (docketUpdated) {
              $scope.showToast('Docket Changes Saved');
              if (!cb) {
                openDocket(docketUpdated.id);
                $scope.loadDocketsList();
              } else {
                cb();
              }
            }, function (err) {
              docket.loading = false;
              $scope.alertService.presentAutoAlert('saveDocket', err);
            });
          } else {
            docket.loading = false;
            docket.editing = false;
            if (cb) {
              cb();
            }
          }
        });
      } else {
        docketService.saveDocket(docket, function (docketUpdated) {
          if (!cb) {
            $state.go('main.groupDocketDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, docketId: docketUpdated.id });
          } else {
            cb();
          }
        }, function (err) {
          docket.loading = false;
          $scope.alertService.presentAutoAlert('saveDocket', err);
        });
      }
    }

    $scope.removeDocketFromCachedList = function (docket) {
      var docketsListParsed = JSON.parse(sessionStorage.getItem('docketsList'));
      if (docketsListParsed) {
        var newList = [];
        for (var i = 0; i < docketsListParsed.length; i++) {
          if (docketsListParsed[i].id != docket.id) {
            newList.push(docketsListParsed[i]);
          }
        }
        sessionStorage.setItem('docketsList', JSON.stringify(newList));
      }
    }

    $scope.deleteDocket = function (docket) {
      mixpanel.track("Clicked Delete Docket");
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete this docket?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          docketService.deleteDocket(docket, function () {
            // remove delete docket from cached list of dockets
            $scope.removeDocketFromCachedList(docket);
            if ($scope.currentOrg) {
              $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            } else {
              $state.go('main.dockets');
            }
          }, function (err) {
            $scope.alertService.presentAutoAlert('deleteDocket', err);
          });
        }
      });
    }

    $scope.editDocket = function (docket) {
      mixpanel.track("Clicked Edit Docket");
      docket.editing = true;
    }

    $scope.cancelEditDocket = function (docket) {
      mixpanel.track("Clicked Cancel Edit Docket");

      var newDocket = false;
      if (docket.id == null) {
        newDocket = true;
      }
      if (newDocket) {
        $scope.closeDocketDesktop($scope.itemEdit)
        return
      }

      var currentDocket = $scope.getCurrentDocketFromParent();
      var diffedDocket = docketService.getDiffedDocket($scope.lastCleanDocket, currentDocket, 'resources', function (diff, count) {
        if (count > 0) {
          var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
            if (actionSelected == 'save') {
              $scope.saveDocket(currentDocket, function () {
                openDocket(docket);
              });
            } else if (actionSelected == 'dontSave') {
              openDocket(docket);
            } else {
              // do nothing - stay where we are
            }
          });
        } else {
          openDocket(docket);
        }
      });
    }

    $scope.sendDocket = function (docket) {
      mixpanel.track("Clicked Send Docket");
      docket.loading = true;
      docket.loadingType = "saving";
      docketService.validateDocket(docket, function () {
        docketService.sendDocket($scope.lastCleanDocket, docket, function (docketUpdated) {
          openDocket(docketUpdated.id);
          $scope.loadDocketsList();
        }, function (error) {
          docket.loading = false;
          $scope.alertService.presentAutoAlert('sendDocket', error);
        });
      }, function (errors) {
        docket.loading = false;
        var reasons = [];
        for (var i = 0; i < errors.length; i++) {
          reasons.push(errors[i].name);
        }
        $scope.alertService.presentAutoValidationAlert('sendDocket', reasons);
      });
    }

    $scope.recallDocket = function (docket) {
      mixpanel.track("Clicked Recall Docket");
      docket.loading = true;
      docket.loadingType = "saving";
      docketService.recallDocket(docket, function (docketUpdated) {
        docket.loading = false;
        openDocket(docketUpdated.id);
        $scope.loadDocketsList();
      }, function (err) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('recallDocket', err);
      });
    }

    $scope.acceptDocket = function (docket) {
      mixpanel.track("Clicked Accept Docket");
      docket.loading = true;
      docket.loadingType = "saving";
      docketService.acceptDocket(docket, function (docketUpdated) {
        docket.loading = false;
        openDocket(docketUpdated.id);
        $scope.loadDocketsList();
      }, function (err) {
        docket.loading = false;
        $scope.alertService.presentAutoAlert('acceptDocket', err);
      });
    }

    $scope.reDraftDocket = function (docket) {
      mixpanel.track("Clicked Recall Docket");
      docket.loading = true;
      docket.loadingType = "saving";
      docketService.reDraftDocket(docket, function (docketUpdated) {
        docket.loading = false;
        openDocket(docketUpdated.id, true);
        $scope.loadDocketsList();
      }, function (err) {
        docket.loading = false;
        $scope.showToast('Error Re-Drafting Docket');
      });
    }

    $scope.hideRejectDocketModal = function() {
      if ($scope.rejectingDocket) {
        $scope.rejectingDocket.loading = false
      }

      $("#rejectDocketModal").fadeOut(100);
      $scope.rejectLoading = false
      $scope.rejectReason.text = '';
      $scope.rejectingDockets = [];
      $scope.rejectingDocket = null
    }

    $scope.acceptRejectDocket = function () {
      $scope.rejectLoading = true

      if ($scope.rejectingDockets.length == 1) {
        docketService.rejectDocket($scope.rejectingDockets[0], $scope.rejectReason.text, function (docketUpdated) {
          $scope.hideRejectDocketModal();
          if (!$scope.bulkReject) {
            openDocket(docketUpdated.id);
          }
          $scope.loadDocketsList();
        }, function (err) {
          $scope.hideRejectDocketModal();
          $scope.alertService.presentAutoAlert('rejectDocket', err);
        });
      } else {
        docketService.rejectBulkDockets($scope.rejectingDockets, $scope.rejectReason.text, function (failures) {
          if (failures && failures.length > 0) {
            $scope.hideRejectDocketModal();
            $scope.alertService.presentAutoAlert('rejectBulkDockets', { status: 202, requestName: 'Reject bulk dockets - failures ' + failures.length + ' of ' + $scope.rejectingDockets.length });
            $scope.loadDocketsList();
          } else {
            $scope.hideRejectDocketModal();
            $scope.alertService.presentAutoAlert('rejectBulkDockets', { status: 200 });
            $scope.loadDocketsList();
          }
          $scope.selected = [];
        });
      }
    }

    $scope.rejectDocket = function (docket) {
      $scope.bulkReject = false;
      $scope.rejectReason.text = '';
      $scope.rejectingDockets = [docket]
      $scope.rejectingDocket = docket
      $("#rejectDocketModal").fadeIn(100);
      mixpanel.track("Clicked Reject Docket");
      docket.loading = true;
      docket.loadingType = 'saving';
    }

    $scope.downloadDocket = function (docket) {
      mixpanel.track("Clicked Download Docket");
      var url = '/v1/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/' + docket.id + '/downloadpdf';
      window.open(url, "_blank");
    }

    $scope.fileDocket = function (docket) {
      mixpanel.track("Clicked File Docket");
      docket.loading = true;
      docket.loadingType = "saving";
      $mdBottomSheet.hide();
      openDocket(docket.id, false, 1);
    }

    $scope.acceptAndFileDocket = function (docket) {
      mixpanel.track("Clicked Accept and File Docket");
      docket.loading = true;
      docket.loadingType = "saving";
      $mdBottomSheet.hide();
      openDocket(docket.id, false, 1, true);
    }

    // Calculate the total time on the docket for the time block
    $scope.getDocketTotalTime = function (docket) {
      if (docket.startTime && docket.endTime) {
        var startTimePart = moment(docket.startTime).format('HH:mm');
        var endTimePart = moment(docket.endTime).format('HH:mm');
        var timeFixerPre = moment().format('DD/MM/YYYY');
        var startTimeFixed = timeFixerPre + "T" + startTimePart;
        var endTimeFixed = timeFixerPre + "T" + endTimePart;
        var startTimeMoment = moment(startTimeFixed, 'DD/MM/YYYYTHH:mm');
        var endTimeMoment = moment(endTimeFixed, 'DD/MM/YYYYTHH:mm');
        var minsTotal = 0;
        // if start time is before end time - standard hours calculation
        // if start time is after end time - overnight shift calculation
        if (!startTimeMoment.isBefore(endTimeMoment)) {
          endTimeMoment = endTimeMoment.add('days', 1);
        }

        minsTotal = parseInt(endTimeMoment.diff(startTimeMoment, 'minutes'));

        if (docket.breakTime) {
          minsTotal -= docket.breakTime;
        }
        if (docket.travelTime) {
          minsTotal += parseInt(docket.travelTime);
        }

        /*var hoursPart = Math.floor(minsTotal / 60);
        var minsPart = minsTotal - (hoursPart * 60);
        display = hoursPart += "h " + minsPart + "m";*/

        docket.totalTime = (minsTotal / 60).toFixed(2) + ' Hrs'
      }
    }

    /*******************************/
    /***** Docket List Controls ****/
    /*******************************/

    $scope.filtersChanged = function (from) {
      if (!$scope.preventReloadWithFilters) {
        // check toDate is after fromDate
        if (moment($scope.filters.endDate).isBefore($scope.filters.startDate)) {
          $scope.filters.endDate = $scope.filters.startDate;
        }

        // check if status filter has changed
        /*var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
        if ( $scope.listView == 'dockets' ) {
          if ( storedFilters.status != $scope.filters.status ) {
            $scope.filters.query.page = 1;
          }
        } else {
          if ( storedFilters.fileStatusTab != $scope.filters.fileStatusTab ) {
            $scope.filters.query.page = 1;
          }
        }*/
        $scope.filters.query.page = 1;

        if ($scope.listView == 'dockets') {
          $scope.loadDocketsList();
        } else if ($scope.listView == 'filing') {
          $scope.loadDocketFilingList();
        } else if ($scope.listView == 'batch') {
          $scope.loadBatchesList();
        }

        sessionStorage.setItem('filters', JSON.stringify($scope.filters));
      } else {
      }
    }

    $scope.filingsChildControllerReady = function () {
      if ($scope.listView == 'filing') {
        // loading of stateParams filters was in here
        $scope.loadDocketFilingList();
      }
    }

    $scope.batchChildControllerReady = function () {
      if ($stateParams.action && $stateParams.action == 'newbatch') {
        $timeout(function () {
          $scope.openDocketBatchModal();
        }, 1000);
      }
      if ($scope.listView == 'batch') {
        // loading of stateParams filters was here
        $scope.loadBatchesList();
      }
    }

    $scope.detailControllerReady = function () {
      if ($stateParams.docketId != null) {
        if ($stateParams.docketId == 'new') {
          if (!($stateParams.author != null && $stateParams.authorName != null)) {
            if ($stateParams.fromOrder != null) {
              newDocket('order', $stateParams.fromOrder);
            } else if ($stateParams.fromJob != null) {
              newDocket('job', $stateParams.fromJob);
            } else {
              newDocket();
            }
          } else {
            if ($stateParams.fromOrder != null) {
              newDocketForAuthor($stateParams.author, $stateParams.authorName, 'order', $stateParams.fromOrder);
            } else if ($stateParams.fromJob != null) {
              newDocketForAuthor($stateParams.author, $stateParams.authorName, 'job', $stateParams.fromJob);
            } else {
              newDocketForAuthor($stateParams.author, $stateParams.authorName);
            }
          }
        } else {
          if ($stateParams.viewMode == 'filing') {
            openDocket($stateParams.docketId, false, 1);
          } else {
            var editing = false;
            if ($stateParams.editing && $stateParams.editing == true) {
              editing = true;
            }
            openDocket($stateParams.docketId, editing, 0);
          }
        }
      }
    }

    $scope.loadDocketsList = function (searchValue, reload) {
      $scope.selected = [];
      $scope.customerFilterOptions = [];
      $scope.customerFilterCounts = {};
      $scope.supplierFilterOptions = [];
      $scope.supplierFilterCounts = {};
      $scope.promise = $q(function (resolve, reject) {
        var params = $scope.getFilterParams();
        params['limit'] = $scope.filters.query.limit;
        params['offset'] = $scope.filters.query.limit * ($scope.filters.query.page - 1);
        params['sort'] = $scope.filters.query.order;
        if (searchValue != null && searchValue != "") {
          params['search'] = searchValue;
        }
        if ($scope.filters.customerSignatureOptions.signed == true && $scope.filters.customerSignatureOptions.unsigned == false) {
          params['customerSigned'] = true;
        } else if ($scope.filters.customerSignatureOptions.signed == false && $scope.filters.customerSignatureOptions.unsigned == true) {
          params['customerSigned'] = false;
        } else {
          params['customerSigned'] = null;
        }
        if ($scope.filters.filedOptions.filed == true && $scope.filters.filedOptions.unfiled == false) {
          params['filed'] = true
        } else if ($scope.filters.filedOptions.filed == false && $scope.filters.filedOptions.unfiled == true) {
          params['filed'] = false
        } else {
          params['filed'] = null
        }
        if ($scope.filters.statusOptions.all == true) {
          params['status'] = null;
        } else {
          var statusParam = "";
          var count = 0;
          var selectedFilters = [];
          for (var i in statusFilterOptions) {
            if ($scope.filters.statusOptions[statusFilterOptions[i]] == true) {
              selectedFilters.push(statusFilterOptions[i]);
            }
          }
          if (selectedFilters.length === 1) {
            params['status'] = selectedFilters[0];
          } else {
            params['statusList'] = selectedFilters.join(',');
          }
        }
        if ($scope.filters.invoicedStatusOptions.all == true) {
          params['invoiced'] = null;
          params['uninvoiced'] = null;
        } else {
          if ($scope.filters.invoicedStatusOptions.invoiced == true) {
            params['invoiced'] = true;
          } else if ($scope.filters.invoicedStatusOptions.uninvoiced == true) {
            params['uninvoiced'] = true;
          }
        }
        // check if this org has custom fields to be injected in dockets list columns
        if ($scope.currentOrg && $scope.currentOrg.features && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.listViewOrder && $scope.currentOrg.features.dockets.listViewOrder.length > 0) {
          var askForTemplateValueStore = false;
          for (var i = 0; i < $scope.currentOrg.features.dockets.listViewOrder.length; i++) {
            if ($scope.currentOrg.features.dockets.listViewOrder[i].indexOf('customField') == 0) {
              askForTemplateValueStore = true;
            }
          }
          if (askForTemplateValueStore) {
            params.supplyTemplateValueStore = true;
          }
        }

        docketService.getDockets(params, function (returnData) {
          var docketsListParsed = docketService.parseDockets(returnData);

          $scope.injectCustomFields(docketsListParsed)

          const activeCustomFilters = $scope.filters.custom.filter(x => x.display && x.value != '')
          if (activeCustomFilters.length > 0) {
            activeCustomFilters.forEach(({ fieldName, value }) => {
              docketsListParsed = docketsListParsed.filter(docket => {
                return docket.customFieldsInjected[fieldName]
                  && (stringSimilarity.compareTwoStrings(docket.customFieldsInjected[fieldName], value) > 0.5
                    || docket.customFieldsInjected[fieldName].toLowerCase().indexOf(value.toLowerCase()) != -1)
              })
            })
          }

          var count = 0;
          if (params.offset <= 0 && returnData.length < params.limit) {
            count = returnData.length;
          } else {
            count = params.offset + (params.limit + 1);
          }
          $scope.loadDocketsListFromParent(docketsListParsed, count);
          if ($scope.currentOrg != null) {
            $scope.loadDocketsListFiledStatus(docketsListParsed);
          }


          if (reload && reload == true) {
            var currentDocket = $scope.getCurrentDocketFromParent();
            if (currentDocket && !currentDocket.editing && currentDocket.id != null) {
              openDocket(currentDocket.id);
            }
          }
          $scope.preventReloadWithFilters = false;
          // store list in sessionStorage
          sessionStorage.setItem('docketsList', JSON.stringify(docketsListParsed));
          sessionStorage.setItem('docketsListCount', count);
          sessionStorage.setItem('docketsQuery', JSON.stringify($scope.filters.query));
          sessionStorage.setItem('filters', JSON.stringify($scope.filters));
          sessionStorage.setItem('docketsLastFilters', JSON.stringify($scope.filters));
          resolve('Done');
        }, function (err) {
          reject('Error');
        });
      });
    }

    $scope.loadDocketsListFiledStatus = function (docketsList) {
      var docketsFiledStatus = {};
      var docketIds = [];
      for (var i = 0; i < docketsList.length; i++) {
        docketIds.push(docketsList[i].id);
        docketsFiledStatus[docketsList[i].id] = false;
      }
      // get docket files
      if (docketIds && docketIds.length > 0) {
        docketService.getBulkDocketFileData(docketIds, function (docketFiles) {
          for (var j = 0; j < docketFiles.length; j++) {
            docketsFiledStatus[docketFiles[j].docketRef] = true;
          }
          $scope.loadInDocketFiledStatusFromParent(docketsFiledStatus);
        });
      }
    }

    $scope.loadDocketsListFullFiledStatus = function (docketsList, cb) {
      var docketFilingRecord = {};
      var docketIds = [];
      for (var i = 0; i < docketsList.length; i++) {
        docketIds.push(docketsList[i].id);
        docketFilingRecord[docketsList[i].id] = { filed: false };
      }
      // get docket files
      if (docketIds && docketIds.length > 0) {
        docketService.getBulkDocketFileData(docketIds, function (docketFiles) {
          for (var j = 0; j < docketFiles.length; j++) {
            docketFilingRecord[docketFiles[j].docketRef] = { filed: true, filingRecord: docketFiles[j] };
          }
          cb(docketFilingRecord);
        });
      }
    }

    /********************************/
    /***** Filing List Controls *****/
    /********************************/

    $scope.filingDetailControllerReady = function () {

    }

    $scope.loadDocketFilingList = function (cb) {
      $scope.promise = $q(function (resolve, reject) {
        var params = $scope.getFilterParams();
        params['limit'] = $scope.filters.query.limit;
        params['offset'] = $scope.filters.query.limit * ($scope.filters.query.page - 1);
        params['sort'] = $scope.filters.query.order;
        params.fileStatus = $scope.filters.fileStatusTab;

        var paramsToSend = angular.copy(params);
        delete paramsToSend.fileStatus;

        docketService.getDockets(paramsToSend, function (returnData) {
          var docketsList = returnData;
          var docketsCount = 0;
          if (params.offset <= 0 && returnData.length < params.limit) {
            docketsCount = returnData.length;
          } else {
            docketsCount = params.offset + (params.limit + 1);
          }
          // list of docket id's for getting existing docket files
          var docketIds = [];
          for (var i = 0; i < docketsList.length; i++) {
            docketIds.push(docketsList[i].id);
          }
          // get docket files
          if (docketIds && docketIds.length > 0) {
            docketService.getBulkDocketFileData(docketIds, function (docketFiles) {
              // populate docket files to dockets with existing
              for (var i = 0; i < docketsList.length; i++) {
                var docketFile = $scope.getDocketFileForDocket(docketsList[i], docketFiles);
                if (docketFile) {
                  docketsList[i].existingDocketFile = docketFile;
                }
              }
              var docketsListParsed = docketService.parseDocketsForFiling(docketsList, params.fileStatus.toLowerCase());
              $scope.loadDocketFilingListFromParent(docketsListParsed, docketsCount);
              $scope.preventReloadWithFilters = false;
              resolve('Done');
              if (cb) {
                cb(docketsListParsed);
              }
            }, function (err) {
              reject('Error');
              if (cb) {
                cb([]);
              }
            });
          } else {
            var docketsListParsed = docketService.parseDocketsForFiling(docketsList, params.fileStatus.toLowerCase());
            $scope.loadDocketFilingListFromParent(docketsListParsed, docketsCount);
            $scope.preventReloadWithFilters = false;
            resolve('Done');
            if (cb) {
              cb(docketsListParsed);
            }
          }
        }, function (err) {
          reject('Error');
          if (cb) {
            cb([]);
          }
        });
      });
    }

    $scope.getDocketFileForDocket = function (docket, docketFilesList) {
      for (var i = 0; i < docketFilesList.length; i++) {
        if (docketFilesList[i].docketRef == docket.id) {
          return docketFilesList[i];
        }
      }
      return null;
    }

    $scope.fileBulkDockets = function (acceptAfterSave) {
      $scope.afterFilingAccept = false;
      if (acceptAfterSave) {
        $scope.afterFilingAccept = true;
      }
      mixpanel.track("Clicked File Bulk Dockets");
      $scope.detailView = "filing";

      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.listFull = false;
      $scope.prepareForFilingFromParent();
      $scope.getPopulatedDockets($scope.selected, function (docketsPopulated) {
        // we need to grab the current filing status of these dockets
        $scope.loadDocketsListFullFiledStatus(docketsPopulated, function (filingRecordByDocket) {
          // assign each filing record to the appropriate docket
          for (var i = 0; i < docketsPopulated.length; i++) {
            if (filingRecordByDocket[docketsPopulated[i].id] != null && filingRecordByDocket[docketsPopulated[i].id].filed == true) {
              docketsPopulated[i].existingDocketFile = filingRecordByDocket[docketsPopulated[i].id].filingRecord;
            }
          }
          $scope.loadBulkDocketsFromParent(docketsPopulated);
        });
      }, function (err) {
        $scope.loadingErrorFromParent('Error loading docket files');
      });
    }

    $scope.acceptAndFileBulkDockets = function () {
      mixpanel.track("Clicked Accept and File Bulk Dockets");

      // check that all selected dockets can be accepted first
      var issue = false;
      for (var i = 0; i < $scope.selected.length; i++) {
        if ($scope.selected[i].status != 'Sent') {
          issue = true;
          break;
        }
      }

      if (issue) {
        $scope.alertService.presentAlert('warning', 'Invalid Dockets Selected', 'You have selected dockets that are not in the Sent state - all dockets must be Sent before they can be Accepted & Filed.');
        return;
      }
      $scope.fileBulkDockets(true);

      /*var itemsToAct = $scope.selected;
      swal({
        title: "Are you sure?",
        text: "Do you really want to accept and file these " + itemsToAct.length + " dockets?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, accept and file them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function(isConfirm){
        if (isConfirm) {
          //$scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted',{status:200});

          docketService.acceptBulkDockets(itemsToAct, function(failures) {
            if ( failures && failures.length > 0 ) {
              $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted', {status:202, requestName: 'Accept bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length});
              $scope.loadDocketsList();
            } else {
              $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted',{status:200});
              //$scope.loadDocketsList();
              $scope.fileBulkDockets();
            }
          });
        }
      });*/
    }

    $scope.getPopulatedDockets = function (dockets, successCb, failureCb) {
      // get list of ids
      var ids = [];
      var existingDocketFiles = {};
      for (var i = 0; i < dockets.length; i++) {
        ids.push(dockets[i].id);
        existingDocketFiles[dockets[i].id] = dockets[i].existingDocketFile;
      }

      var params = {};
      params.ids = ids.join(',');

      // get populated list of dockets by ids
      docketService.getDockets(params, function (docketsList) {
        // now re-attach exsitingDocketFiles from first dockets list
        for (var i = 0; i < docketsList.length; i++) {
          docketsList[i].existingDocketFile = existingDocketFiles[docketsList[i].id];
        }
        successCb(docketsList);
      }, function (err) {
        failureCb(err);
      });
    }

    $scope.closeDocketFiling = function () {
      $scope.splitListFunc.slideTableListDetailClosed();
      $scope.listFull = true;
      $scope.clearDocketFilingFromParent();
      $scope.detailView = 'dockets';
      $scope.clearDocketFromParent();
      $scope.selected = [];
    }

    var validateDocketFileBeforeSave = function (docket) {
      if (docket.docketFiling.method == 'split') {
        var totalPercentage = 0;
        for (var i = 0; i < docket.docketFiling.activityCodes.length; i++) {
          if (docket.docketFiling.activityCodes[i].fileCode == null) {
            return 'missingFileCode';
          }
          totalPercentage += parseFloat(docket.docketFiling.activityCodes[i].splitPercentage);
        }
        totalPercentage = parseFloat(totalPercentage.toFixed(2))
        if (totalPercentage != 100) {
          return 'percentageError';
        } else {
          return true;
        }
      } else if (docket.docketFiling.method == 'lines') {
        for (var i = 0; i < docket.docketFiling.linesSummary.length; i++) {
          for(var j = 0; j < docket.docketFiling.linesSummary[i].activityCodes.length; j++) {
            if (docket.docketFiling.linesSummary[i].activityCodes[j].fileCode == null) {
              return 'missingFileCode';
            }
          }
          var totalPercent =
            docket.docketFiling.linesSummary[i].activityCodes
            .map(activityCode => activityCode.percentage)
            .reduce((a, b) => a + b, 0)

          if (totalPercent != 100) {
            return 'percentageError';
          }
        }
        return true;
      } else if (docket.docketFiling.method == null) {
        return 'missingFileCode';
      } else {

        return true;
      }
    }

    var validateBulkDocketFileBeforeSave = function (docketFiling) {
      if (docketFiling.method == 'split') {
        var totalPercentage = 0;
        if (!docketFiling.activityCodes) {
          return 'missingFileCode';
        }
        for (var i = 0; i < docketFiling.activityCodes.length; i++) {
          if (docketFiling.activityCodes[i].fileCode == null) {
            return 'missingFileCode';
          }
          totalPercentage += parseFloat(docketFiling.activityCodes[i].splitPercentage);
        }
        totalPercentage = parseFloat(totalPercentage.toFixed(2))
        if (totalPercentage != 100) {
          return 'percentageError';
        } else {
          return true;
        }
      } else if (docketFiling.method == 'lines') {
        for (var i = 0; i < docketFiling.linesSummary.length; i++) {
          var totalPercentage = 0;
          for (var j = 0; j < docketFiling.linesSummary[i].activityCodes.length; j++) {
            totalPercentage += docketFiling.linesSummary[i].activityCodes[j].percentage
            if (docketFiling.linesSummary[i].activityCodes[j].fileCode == null) {
              return 'missingFileCode';
            }
          }
          if (totalPercentage != 100) {
            return 'percentageError';
          }
        }
        return true;
      } else if (docketFiling.method == null) {
        return 'missingFileCode';
      } else {
        return true;
      }
    }

    function saveFiling(docket, docketFiling) {
      docketService.saveDocketFiling(docketFiling, function (success) {
        docket.loading = false;
        openDocket(docket.id, false, 1);
        $scope.loadDocketsList();
      }, function (err) {
        docket.docketFiling.loading = false;
        $scope.alertService.presentAutoAlert('fileDocket', err);
      });
    }

    $scope.saveDocketFile = function (docket) {
      // validate if filing adds up to 100%
      var validateResult = validateDocketFileBeforeSave(docket);
      if (validateResult == true) {
        docket.docketFiling.loading = true;
        docket.docketFiling.loadingType = 'saving';

        var docketFiling = angular.copy(docket.docketFiling);
        docketFiling.dockets = [];
        docketFiling.dockets.push(docket);

        if ($scope.afterFilingAccept) {
          docketService.acceptDocket(docket, function (docketUpdated) {
            saveFiling(docket, docketFiling)
          }, function (err) {
            docket.loading = false;
            $scope.alertService.presentAutoAlert('acceptDocket', err);
          });

        } else {
          saveFiling(docket, docketFiling)
        }
      } else if (validateResult == 'missingFileCode') {
        $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - a file code is missing. Please check and try again.");
      } else if (validateResult == 'percentageError') {
        $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - filing percentages do not add to 100%.");
      }
    }

    $scope.saveDocketFiling = function (docketFiling) {
      docketFiling.loading = true;

      // validate docket file before save
      var validateResult = validateBulkDocketFileBeforeSave(docketFiling);
      if (validateResult == true) {
        docketService.saveDocketFiling(docketFiling, function (success) {
          $scope.loadDocketFilingList(function (listParsed) {
            // Re-assign filing status's and existingDocketFiles to previously selected dockets
            for (var i = 0; i < $scope.selected.length; i++) {
              for (var j = 0; j < listParsed.length; j++) {
                if (listParsed[j].id == $scope.selected[i].id && listParsed[j].existingDocketFile != null) {
                  $scope.selected[i].existingDocketFile = listParsed[j].existingDocketFile;
                }
              }
            }
            if ($scope.afterFilingAccept) {
              docketService.acceptBulkDockets($scope.selected, function (failures) {
                if (failures && failures.length > 0) {
                  $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted', { status: 202, requestName: 'Accept bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length });
                  $scope.loadDocketsList();
                } else {
                  $scope.alertService.presentAutoAlert('acceptFileBulkDocketsAccepted', { status: 200 });
                  $scope.fileBulkDockets();
                  $scope.loadDocketsList();
                }
              });
            } else {
              $scope.fileBulkDockets();
              $scope.loadDocketsList();
            }
          });
        }, function (err) {
          $scope.alertService.presentAutoAlert('fileDocket', err);
        });
      } else if (validateResult == 'missingFileCode') {
        $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - a file code is missing. Please check and try again.");
        docketFiling.loading = false;
      } else if (validateResult == 'percentageError') {
        $scope.alertService.presentAlert("warning", "Oops", "Docket filing could not be saved - filing percentages do not add to 100%.");
        docketFiling.loading = false;
      }
    }

    /******************************/
    /***** List View Controls *****/
    /******************************/

    $scope.selectContactFilter = function (type) {
      var existingContact = null;
      if (type == 'customer') {
        if ($scope.filters.customerContact != null) {
          existingContact = $scope.filters.customerContact;
        }
      } else {
        if ($scope.filters.supplierContact != null) {
          existingContact = $scope.filters.supplierContact;
        }
      }
      $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
        if (contactSelected != null) {
          if (type == 'customer') {
            $scope.filters.customerContact = contactSelected;
          } else {
            $scope.filters.supplierContact = contactSelected;
          }
          $scope.filtersChanged(type + ' contact');
        }
      });
    }

    $scope.selectContactForDocket = function (docket, companyType, cb) {
      $scope.selectContactCallback = cb;
      var existingContacts = [];
      var selectedContact = null;
      if (companyType == 'customerContact') {
        if (docket.supplierContact != null) {
          existingContacts.push(docket.supplierContact);
        }
        if (docket.customerContact != null) {
          selectedContact = docket.customerContact;
        }
      } else if (companyType == 'supplierContact') {
        if (docket.customerContact != null) {
          existingContacts.push(docket.customerContact);
        }
        if (docket.supplierContact != null) {
          selectedContact = docket.supplierContact;
        }
      }

      if (selectedContact) {
        var newContactAddresses = [];
        var keys = Object.keys(selectedContact.contactAddresses);
        for (var i = 0; i < keys.length; i++) {
          var newContactAddress = {};
          newContactAddress.emailAddress = keys[i]
          newContactAddress.accessLevel = selectedContact.contactAddresses[keys[i]][0];
          newContactAddresses.push(newContactAddress);
        }
        selectedContact.contactAddresses = newContactAddresses;
      }

      $scope.contactSelectFromParent(existingContacts, selectedContact, function (contactSelected) {
        $scope.selectContactCallback(contactSelected);
      });
    }

    $scope.selectContactForShare = function (cb) {
      $scope.contactSelectFromParent(null, null, function (contactSelected) {
        cb(contactSelected);
      });
    }

    $scope.selectOrderForDocket = function (options, cb) {
      $scope.selectOrderCallback = cb;
      $scope.orderSelectFromParent(options, function (orderSelected) {
        $scope.selectOrderCallback(orderSelected);
      });
    }

    $scope.selectOrderFilter = function () {
      var currentOrder = null;
      var options = {};
      if ($scope.filters.order != null) {
        options.currentOrder = $scope.filters.order;
      }
      $scope.orderSelectFromParent(options, function (orderSelected) {
        if (orderSelected != null) {
          $scope.filters.order = orderSelected;
          $scope.filtersChanged('order');
        }
      });
    }

    $scope.selectJobFilter = function () {
      var currentJob = null;
      if ($scope.filters.job != null) {
        currentJob = $scope.filters.job;
      }
      $scope.jobSelectFromParent(currentJob, function (jobSelected) {
        if (jobSelected != null) {
          $scope.filters.job = jobSelected;
          $scope.filtersChanged('job select');
        }
      });
    }

    $scope.selectJobForDocket = function (options, cb) {
      $scope.selectJobCallback = cb;
      $scope.jobSelectFromParent(null, function (jobSelected) {
        $scope.selectJobCallback(jobSelected);
      });
    }

    $scope.selectTemplateForDocket = function (currentTemplate, cb) {
      $scope.selectTemplateCallback = cb;
      $scope.templateSelectFromParent(currentTemplate, function (templateSelected) {
        $scope.selectTemplateCallback(templateSelected);
      });
    }

    $scope.selectOrganisationForDocket = function (docket, cb) {
      $("#assignDocketModal").fadeIn(100);
      $scope.selectOrganisationCallback = cb;
      $scope.assignDocket = {};
      $scope.assignDocket.selected = [];
      $scope.assignDocket.docketNumber = docket.docketNumber;
      $scope.assignDocket.organisations = accessControl.allowedOrganisations();
    }

    $scope.assignDocketContinue = function () {
      var group = $scope.assignDocket.selected[0];
      $("#assignDocketModal").fadeOut(100);
      $scope.selectOrganisationCallback(group);
    }

    $scope.closeAssignDocketModal = function () {
      $("#assignDocketModal").fadeOut(100);
      $scope.selectOrganisationCallback(null, null);
    }

    $scope.selectResourceForDocket = function (docket, cb) {
      $scope.selectResourceCallback = cb;

      // Get list of available categories
      var categories = {};
      for (var i = 0; i < docket.template.interactionTemplates.length; i++) {
        var interactionTemplate = docket.template.interactionTemplates[i];
        for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
          if (categories[interactionTemplate.actorCategories[j].id] == null) {
            categories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
            categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
          }
          // Check if resources in category are to be filtered by order or not
          if (categories[interactionTemplate.actorCategories[j].id].filterByOrder == true &&
            interactionTemplate.actorFromOrder != true) {
            categories[interactionTemplate.actorCategories[j].id].filterByOrder = false;
          } else if (categories[interactionTemplate.actorCategories[j].id].filterByOrder != true &&
            interactionTemplate.actorFromOrder == true) {
            categories[interactionTemplate.actorCategories[j].id].filterByOrder = true;
          }
        }
      }

      // convert categories dict to array
      var categoriesArray = [];
      var keys = Object.keys(categories);
      for (var i = 0; i < keys.length; i++) {
        categoriesArray.push(categories[keys[i]]);
      }

      var lineItems = [];
      // Get list of line items from job/order that are to be filtered against
      if (docket.jobRef != null && docket.jobRef.lineItems != null) {
        lineItems = docket.jobRef.lineItems;
      } else if (docket.orderRef != null && docket.orderRef.lineItems != null) {
        lineItems = docket.orderRef.lineItems;
      }

      // Get list of existing resources on the docket
      var existingResources = [];
      if (docket && docket.resources) {
        for (var i = 0; i < docket.resources.length; i++) {
          if (!docket.resources[i].delete) {
            existingResources.push(docket.resources[i].resource.id);
          }
        }
      }

      var options = { categories: categoriesArray, lineItems: lineItems, existingResources: existingResources };
      $scope.desktopResourceSelectFromParent(options, function (resourcesSelected) {
        $scope.selectResourceCallback(resourcesSelected);
      });
    }

    /*******************************/
    /***** Batch List Controls *****/
    /*******************************/

    $scope.batchDetailControllerReady = function () {
      if ($stateParams.batchId != null) {
        openBatch($stateParams.batchId);
      }
    }

    $scope.loadBatchesList = function () {
      $scope.selected = [];
      $scope.promise = $q(function (resolve, reject) {
        var params = $scope.getFilterParams();
        params['limit'] = $scope.filters.query.limit;
        params['offset'] = $scope.filters.query.limit * ($scope.filters.query.page - 1);
        params['sort'] = $scope.filters.query.order;

        batchService.getBatches(params, function (returnData) {
          var batchesList = returnData;
          var count = 0;
          if (params.offset <= 0 && returnData.length < params.limit) {
            count = returnData.length;
          } else {
            count = params.offset + (params.limit + 1);
          }
          $scope.loadBatchesListFromParent(batchesList, count);
          $scope.preventReloadWithFilters = false;
          resolve('Done');
        }, function (err) {
          reject('Error');
        });
      });
    }

    $scope.openBatchDesktop = function (batch) {
      $state.go('main.groupBatchDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, batchId: batch.id });
    }

    var openBatch = function (batch) {
      $scope.batchLoadingError = null;
      $scope.splitListFunc.slideTableListDetailOpen();
      $scope.listFull = false;
      $scope.detailView = 'batch';
      $scope.prepareForBatchFromParent(batch);
      batchService.getBatch(batch, function (fullBatch) {
        $scope.loadBatchFromParent(fullBatch);
      }, function (err) {
        $scope.batchLoadingError = "Error Getting Batch";
        $scope.batchLoadingErrorFull = err;
      });
    }

    var closeBatch = function () {
      $scope.splitListFunc.slideTableListDetailClosed();
      $scope.listFull = true;
      $scope.clearBatchFromParent();
      return;
    }

    $scope.closeBatchDesktop = function () {
      $state.go('main.groupBatches', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }

    $scope.deleteBatch = function (batch) {
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete this batch?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          batchService.deleteBatch(batch, function () {
            $state.go('main.groupBatches', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }, function (err) {
            $scope.alertService.presentAutoAlert('deleteBatch', err);
          });
        }
      });
    }

    $scope.bulkBatchDelete = function () {
      var itemsToDelete = $scope.selected;
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete these " + itemsToDelete.length + " batches?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          batchService.deleteBulkBatches(itemsToDelete, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkBatches', { status: 202, requestName: 'Delete bulk batches - failures ' + failures.length + ' of ' + itemsToDelete.length });
              $scope.loadBatchesList();
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkBatches', { status: 200 });
              $scope.loadBatchesList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    /**************************/
    /***** Modal Controls *****/
    /**************************/

    $scope.newInteractionForResource = function (docket, resource, cb) {
      $scope.newInteractionCallback = cb;
      $scope.newInteractionFromParent(docket, resource, function (interaction) {
        $scope.newInteractionCallback(interaction);
      });
    }

    $scope.editInteractionForResource = function (interaction, docket, resource, cb) {
      $scope.editInteractionCallback = cb;
      $scope.editInteractionFromParent(docket, interaction, resource, function (interaction) {
        $scope.editInteractionCallback(interaction);
      });
    }

    $scope.captureSignatureForDocket = function (entity, nameRequired, name, terms, template, cb) {
      $scope.captureSignatureCallback = cb;
      $scope.captureSignatureFromParent(entity, nameRequired, name, terms, template, function (signatureObject) {
        $scope.captureSignatureCallback(signatureObject);
      });
    }

    $scope.editChecklistForDocket = function (checklistsData, checklist, cb) {
      $scope.checklistCallback = cb;
      $scope.openChecklistFromParent(checklistsData, checklist, function (checklistReturned) {
        $scope.checklistCallback(checklistReturned);
      });
    }

    /**** Summary Report Modal ****/

    $scope.openSummaryReport = function () {
      mixpanel.track("Clicked Open Docket Summary Report");
      $scope.summaryReport = { 'stage': 'filter', 'loading': false, 'includeSupporting': false, 'includeInteractionFields': false, 'aggregateInteractions': true, 'startDate': moment().toDate(), 'endDate': moment().toDate(), docType: 'pdf', status: ['draft', 'sent', 'accepted', 'rejected'], sortBy: 'docketNumber' };
      $("#summaryReportModal").fadeIn(100);
    }

    $scope.closeSummaryReportModal = function () {
      mixpanel.track("Abandoned Docket Summary Report");
      $("#summaryReportModal").fadeOut(100);
    }

    /**** File Code Report Modal ****/

    $scope.openFileCodeReport = function () {
      mixpanel.track("Clicked Open File Code Report");
      $scope.fileCodeReport = { 'stage': 'reportType', 'loading': false, 'billableOnly': false, 'startDate': moment().toDate(), 'endDate': moment().toDate(), docType: 'xlsx', status: ['draft', 'sent', 'accepted', 'rejected'] };
      $("#fileCodeReportModal").fadeIn(100);
    }

    $scope.closeFileCodeReportModal = function () {
      mixpanel.track("Abandoned File Code Report");
      $("#fileCodeReportModal").fadeOut(100);
    }

    $scope.dateChanged = function (date) {
    }

    $scope.fileCodeValid = function () {
      return true;
    }

    $scope.generateFileCodeReport = function (fileCodeReport) {
      mixpanel.track("Clicked Generate File Code Report");
      $scope.fileCodeReport.loading = true;
      var postBody = {
        'fromDate': moment($scope.fileCodeReport.startDate).format('YYYY-MM-DD'),
        'toDate': moment($scope.fileCodeReport.endDate).format('YYYY-MM-DD'),
        'docType': $scope.fileCodeReport.docType,
        'billableOnly': $scope.fileCodeReport.billableOnly,
        'type': $scope.fileCodeReport.type
      };

      if ($scope.fileCodeReport.customerContact) {
        var emailAddresses = [];
        for (var i = 0; i < $scope.fileCodeReport.customerContact.contactAddresses.length; i++) {
          emailAddresses.push($scope.fileCodeReport.customerContact.contactAddresses[i].emailAddress);
        }
        postBody.customer = emailAddresses;
      }
      if ($scope.fileCodeReport.supplierContact) {
        var emailAddresses = [];
        for (var i = 0; i < $scope.fileCodeReport.supplierContact.contactAddresses.length; i++) {
          emailAddresses.push($scope.fileCodeReport.supplierContact.contactAddresses[i].emailAddress);
        }
        postBody.supplier = emailAddresses;
      }
      if ($scope.fileCodeReport.status && $scope.fileCodeReport.status.length > 0) {
        postBody.statusList = $scope.fileCodeReport.status.join(',');
      }
      $http.post($scope.fullApiPath + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/docketfiles/report", postBody, {
        withCredentials: true,
      }).success(function (res) {
        var json = res;
        $scope.fileCodeReport.generatedFiles = [];
        $scope.fileCodeReport.generatedFiles.push(json.url);
        $scope.fileCodeReport.loading = false;
        $scope.fileCodeReport.stage = "fileList";
        mixpanel.track("File Code Report Generated");
      }).error(function (err) {
        $scope.fileCodeReport.stage = 'error';
        $scope.fileCodeReport.loading = false;
        mixpanel.track("File Code Report Failed");
      })
    }

    $scope.statusSelected = function (statusObject, status) {
      if (statusObject && statusObject.indexOf(status) != -1) {
        return true;
      }

      return false;
    }

    $scope.toggleStatus = function (statusObject, status) {
      var index = statusObject.indexOf(status);
      if (index != -1) {
        statusObject.splice(index, 1);
      } else {
        statusObject.push(status);
      }
    }

    $scope.searchMembers = function (searchTerm) {
      return $q(function (resolve, reject) {
        userService.getMembers({ search: searchTerm }, function (membersList) {
          resolve(membersList);
        }, function (err) {
          reject();
        });
      });
    }

    $scope.toggleIncludeSupporting = function () {
      $scope.summaryReport.includeSupporting = !$scope.summaryReport.includeSupporting;
    }

    $scope.generateSummaryReport = function (summaryReport) {
      mixpanel.track("Clicked Generate Docket Summary Report");
      $scope.summaryReport.loading = true;
      var postBody = { 'fromDate': moment($scope.summaryReport.startDate).format('YYYY-MM-DD'), 'toDate': moment($scope.summaryReport.endDate).format('YYYY-MM-DD'), 'docType': $scope.summaryReport.docType };
      if ($scope.summaryReport.customerDisplayName) {
        postBody.customerDisplayName = $scope.summaryReport.customerDisplayName;
      }
      if ($scope.summaryReport.supplierDisplayName) {
        postBody.supplierDisplayName = $scope.summaryReport.supplierDisplayName;
      }
      if ($scope.summaryReport.customerContact) {
        var emailAddresses = [];
        for (var i = 0; i < $scope.summaryReport.customerContact.contactAddresses.length; i++) {
          emailAddresses.push($scope.summaryReport.customerContact.contactAddresses[i].emailAddress);
        }
        postBody.customerDisplayName = $scope.summaryReport.customerContact.displayName;
        postBody.customer = emailAddresses;
      }
      if ($scope.summaryReport.supplierContact) {
        var emailAddresses = [];
        for (var i = 0; i < $scope.summaryReport.supplierContact.contactAddresses.length; i++) {
          emailAddresses.push($scope.summaryReport.supplierContact.contactAddresses[i].emailAddress);
        }
        postBody.supplier = emailAddresses;
      }
      if ($scope.summaryReport.order) {
        postBody.orderRef = $scope.summaryReport.order.id;
      }
      if ($scope.summaryReport.status && $scope.summaryReport.status.length > 0) {
        postBody.statusList = $scope.summaryReport.status.join(',');
      }
      if ($scope.summaryReport.author) {
        postBody.author = $scope.summaryReport.author.id;
      }
      if ($scope.summaryReport.sortBy) {
        postBody.sort = $scope.summaryReport.sortBy;
      }
      postBody.includeSupporting = $scope.summaryReport.includeSupporting;
      postBody.includeInteractionFields = $scope.summaryReport.includeInteractionFields;
      postBody.aggregateInteractions = $scope.summaryReport.aggregateInteractions;
      $http.post($scope.fullApiPath + '/organisations/' + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/dockets/summarypdf", postBody, {
        withCredentials: true,
      }).success(function (res) {
        var json = res;
        $scope.summaryReport.generatedFiles = [];
        $scope.summaryReport.generatedFiles.push(json.url);
        $scope.summaryReport.loading = false;
        $scope.summaryReport.stage = "fileList";
        mixpanel.track("Docket Summary Report Generated");
      }).error(function (err) {
        $scope.summaryReport.stage = 'error';
        $scope.summaryReport.loading = false;
        mixpanel.track("Docket Summary Report Failed");
      })
    }

    $scope.selectModalContactFilter = function (filterObject, contactField, modalFor) {
      $("#" + modalFor).hide();
      var existingContact = null;
      if (filterObject[contactField] != null && filterObject[contactField].id != null) {
        existingContact = filterObject[contactField];
      }
      $scope.contactSelectFromParent(null, existingContact, function (contactSelected) {
        if (contactSelected != null) {
          filterObject[contactField] = contactSelected;
        }
        $("#" + modalFor).show();
      });
    }

    $scope.selectModalOrderFilter = function (filterObject, modalFor) {
      $("#" + modalFor).hide();
      var options = {};
      if (filterObject.order) {
        options.currentOrder = filterObject.order;
      }
      if (filterObject.customerContact) {
        var emailAddresses = [];
        if (filterObject.customerContact.contactAddresses) {
          filterObject.customerContact.contactAddresses.forEach(function (contactAddress) {
            emailAddresses.push(contactAddress.emailAddress);
          });
        }
        options.customer = emailAddresses;
      }
      $scope.orderSelectFromParent(options, function (orderSelected) {
        if (orderSelected != null) {
          filterObject.order = orderSelected;
        }
        $("#" + modalFor).show();
      });
    }

    /**** Generate Docket Batch Modal ****/

    var checkAndPrefillCustomer = function (dockets, cb) {
      if (!$scope.filters.customerContact) {
        var docketCustomerContacts = {};
        //var otherError = false;
        for (var i = 0; i < dockets.length; i++) {
          if (!dockets[i].customerContact || !dockets[i].customerContact.displayName) {
            //otherError = true;
            break;
          }
          docketCustomerContacts[dockets[i].customerContact.displayName] = true;
        }

        let customerContactName = null;
        /*if ( otherError || Object.keys(docketCustomerContacts).length > 1 ) {
          $scope.newDocketBatch = {'stage':'listGeneratedError','loading':false,attachPDFDockets: true};
          $("#docketBatchModal").fadeIn(100);
          return;
        } else*/ if (Object.keys(docketCustomerContacts).length == 1) {
          customerContactName = Object.keys(docketCustomerContacts)[0];

          addressBookService.getAddressBook({ search: customerContactName }, function (contactsFound) {
            if (contactsFound.length == 0) {
              cb(null)
              return
            } else {
              var customerContactFound = contactsFound[0];
              if (customerContactFound.externalIdentifiers) {
                for (var i = 0; i < customerContactFound.externalIdentifiers.length; i++) {
                  if (customerContactFound.externalIdentifiers[i].type == 'xero') {
                    customerContactFound.xeroContact = customerContactFound.externalIdentifiers[i];
                    break;
                  }
                }
              }
              cb(customerContactFound);
            }
          }, function (err) {
            cb(null);
          });
        } else {
          cb(null)
        }
      } else {
        cb($scope.filters.customerContact);
      }
    }

    $scope.openDocketBatchModal = function (dockets) {
      //$scope.newDocketBatch = {'stage':'checkConnection','loading':false, 'startDate':moment().toDate(),'endDate':moment().toDate(),status:['draft','sent','accepted','rejected']};
      if (!dockets) {
        $scope.newDocketBatch = { 'method': 'filter', 'stage': 'identifier', 'loading': false, 'startDate': moment().toDate(), 'endDate': moment().toDate(), status: ['sent', 'accepted'], uninvoicedDockets: true, attachPDFDockets: true, invoiceType: 'lines' };
      } else {
        checkAndPrefillCustomer(dockets, function (customerContactPrefilled) {
          var todaysDate = moment().toDate();
          // check dockets all have the same customerContact
          var docketIds = [];
          var customersDetected = {};
          var customerRefNosDetected = {};
          //for ( var i = 0; i < dockets.length; i++ ) {
          dockets.filter(docket => docket.customerContact).forEach(docket => {
            docketIds.push(docket.id);
            if (!customersDetected[docket.customerContact.displayName]) {
              customersDetected[docket.customerContact.displayName] = {};
            }
            if (docket.customerRefNo && docket.customerRefNo != undefined && !customerRefNosDetected[docket.customerRefNo]) {
              customerRefNosDetected[docket.customerRefNo] = 1;
            }
            var contactKeys = Object.keys(docket.customerContact.contactAddresses);
            for (var j = 0; j < contactKeys.length; j++) {
              if (!customersDetected[docket.customerContact.displayName][contactKeys[j]]) {
                customersDetected[docket.customerContact.displayName][contactKeys[j]] = 1;
              }
            }
          })
          docketIds = docketIds.join(',');
          var customersDetectedKeys = Object.keys(customersDetected);
          var customerRefNosDetectedKeys = Object.keys(customerRefNosDetected);
          $scope.newDocketBatch = { 'method': 'docketsSelected', 'stage': 'preconfigure', 'loading': false, attachPDFDockets: true, docketIds: docketIds, date: todaysDate };
          if (customerContactPrefilled) {
            $scope.newDocketBatch.customerContact = customerContactPrefilled;
          } /*else {
            $scope.newDocketBatch = {'stage':'listGeneratedError','loading':false,attachPDFDockets: true, docketIds: docketIds};
            $("#docketBatchModal").fadeIn(100);
            return;
          }*/
          $scope.newDocketBatch.invoiceType = 'lines';
          // if all dockets have same customerRefNo - prefill
          if (customerRefNosDetectedKeys.length == 1) {
            $scope.newDocketBatch.localIdentifier = customerRefNosDetectedKeys[0];
          }
        });
      }
      $("#docketBatchModal").fadeIn(100);
    }

    $scope.closeDocketBatchModal = function () {
      $("#docketBatchModal").fadeOut(100);
      $scope.loadBatchesList();
    }

    $scope.docketBatchIdentifierNext = function () {
      // check that special characters aren't in localIdentifier field
      const invalidChars = ['/', '&', '#', '?', '%', '\\']
      if (invalidChars.map(char => $scope.newDocketBatch.localIdentifier.indexOf(char) != -1).filter(x => x == true).length > 0) {
        $scope.alertService.presentAlert('warning', 'Invalid Field Value', '/, \\, #, %, ? and & characters are not permitted in this field. Please update your reference and try again.');
        return;
      }
      if ($scope.newDocketBatch.docketIds != null) {
        $scope.generateDocketBatch();
      } else {
        $scope.newDocketBatch.stage = 'filter';
      }
    }

    $scope.generateDocketBatch = function () {
      $scope.newDocketBatch.loading = true;
      var postBody = {};
      if ($scope.newDocketBatch.startDate && $scope.newDocketBatch.endDate) {
        postBody.fromDate = moment($scope.newDocketBatch.startDate).format('YYYY-MM-DD');
        postBody.toDate = moment($scope.newDocketBatch.endDate).format('YYYY-MM-DD');
      }
      if ($scope.newDocketBatch.uninvoicedDockets) {
        postBody.uninvoiced = true;
      }
      // only filter by the customer contact if we don't already know the dockets selected for the batch
      if ($scope.newDocketBatch.customerContact && !$scope.newDocketBatch.docketIds) {
        var emailAddresses = [];
        for (var i = 0; i < $scope.newDocketBatch.customerContact.contactAddresses.length; i++) {
          emailAddresses.push($scope.newDocketBatch.customerContact.contactAddresses[i].emailAddress.toLowerCase());
        }
        if (emailAddresses.length > 0) {
          postBody.customer = emailAddresses.join(',');
        }
      }
      if ($scope.newDocketBatch.order) {
        postBody.orderRef = $scope.newDocketBatch.order.id;
      }
      if ($scope.newDocketBatch.status && $scope.newDocketBatch.status.length > 0) {
        postBody.statusList = $scope.newDocketBatch.status.join(',');
      }
      if ($scope.newDocketBatch.docketIds) {
        postBody.ids = $scope.newDocketBatch.docketIds;
      }
      docketService.getDockets(postBody, function (dockets) {
        // get docket ids
        var docketIds = [];
        dockets.forEach(function (docket) {
          docketIds.push(docket.id);
        });
        var identifier = $scope.newDocketBatch.localIdentifier.toUpperCase().replace(/\s/g, '');
        var attributionObj = {};
        if ($scope.newDocketBatch.customerContact) {
          attributionObj.customer = { addressBookId: $scope.newDocketBatch.customerContact.id };
        }
        if ($scope.newDocketBatch.supplierContact) {
          attributionObj.supplier = { addressBookId: $scope.newDocketBatch.supplierContact.id };
        }
        var invoiceDate = moment().format('YYYY-MM-DD');
        if ($scope.newDocketBatch.date) {
          invoiceDate = moment($scope.newDocketBatch.date).format('YYYY-MM-DD');
        }
        var docketBatchPostObj = {};
        if ($scope.newDocketBatch.batchFull && $scope.newDocketBatch.batchFull.id != null) {
          var existingDocketIds = [];
          if ($scope.newDocketBatch.batchFull.dockets) {
            existingDocketIds = $scope.newDocketBatch.batchFull.dockets;
          }
          var removeDocketIds = [];
          for (var i = 0; i < existingDocketIds.length; i++) {
            if (docketIds.indexOf(existingDocketIds[i]) == -1) {
              removeDocketIds.push(existingDocketIds[i]);
            }
          }
          docketBatchPostObj = { date: invoiceDate, id: $scope.newDocketBatch.batchFull.id, dockets: { remove: removeDocketIds, add: docketIds }, attribution: attributionObj };
        } else {
          docketBatchPostObj = { date: invoiceDate, localIdentifier: identifier, dockets: docketIds, attribution: attributionObj };
        }
        batchService.saveBatch(docketBatchPostObj, function (batchCreated) {
          batchService.getBatch(batchCreated.id, function (batchFull) {
            $scope.newDocketBatch.stage = 'itemSummary';
            $scope.newDocketBatch.batchFull = batchFull;
            for (var i = 0; i < $scope.newDocketBatch.batchFull.aggregations.length; i++) {
              $scope.newDocketBatch.batchFull.aggregations[i].export = true;
            }
            $scope.newDocketBatch.loading = false;
          }, function (err) {
            $scope.newDocketBatch.loading = false;
            $scope.newDocketBatch.stage = 'error';
          });
        }, function (err) {
          if (err.status == 409) {
            $scope.newDocketBatch.errorType = "exists";
          }
          $scope.newDocketBatch.loading = false;
          $scope.newDocketBatch.stage = 'error';
        });
      }, function (err) {
        $scope.newDocketBatch.loading = false;
        $scope.newDocketBatch.stage = 'error';
      });
    }

    $scope.updateBatchItems = function () {
      $scope.newDocketBatch.loading = true;
      var selectedResources = [];

      $scope.newDocketBatch.batchFull.aggregations.forEach(function (aggregate) {
        if (aggregate.export == true) {
          selectedResources.push({ resourceId: aggregate.resource.id, interactionName: aggregate.interactionName });
        }
      });
      var batchUpdate = { id: $scope.newDocketBatch.batchFull.id, selectedResources: { add: selectedResources } };
      batchService.saveBatch(batchUpdate, function (batchUpdated) {
        batchService.getBatch(batchUpdated.id, function (batchFull) {
          $scope.newDocketBatch.batchFull = batchFull;
          if (!$scope.newDocketBatch.customerContact || $scope.newDocketBatch.customerContact.xeroContact == null || $scope.newDocketBatch.customerContact.xeroContact.externalId == null) {
            $scope.newDocketBatch.requiresXeroContactSync = true;
            xeroService.getXeroContacts(function (contacts) {
              $scope.xeroContacts = contacts;
              $scope.newDocketBatch.stage = 'invoiceDetails';
              $scope.newDocketBatch.loading = false;
              if ($scope.newDocketBatch.method == 'docketsSelected') {
                $scope.newDocketBatch.stage = 'creatingInvoice';
              }

              if ($scope.newDocketBatch.order && $scope.newDocketBatch.order.customerContact) {
                addressBookService.getAddressBook({ search: $scope.newDocketBatch.order.customerContact.displayName }, function (contactItems) {
                  if (contactItems[0] != undefined) {
                    const xeroId = contactItems[0].externalIdentifiers.filter(x => x.type == 'xero')[0].externalId
                    if (xeroId) {
                      const xeroContact = $scope.xeroContacts.find(contact => contact.externalId == xeroId)
                      $scope.newDocketBatch.selectedXeroContact = xeroContact
                    }
                  }
                })
              }

            }, function (err) {
              $scope.newDocketBatch.stage = 'invoiceDetails';
              $scope.newDocketBatch.loading = false;
            });
          } else {
            $scope.newDocketBatch.requiresXeroContactSync = false;
            $scope.newDocketBatch.stage = 'invoiceDetails';
            $scope.newDocketBatch.loading = false;
            if ($scope.newDocketBatch.method == 'docketsSelected') {
              $scope.newDocketBatch.loading = true;
              $scope.newDocketBatch.stage = 'creatingInvoice';
              $scope.createBatchInvoice();
            }
          }
        }, function (err) {
          $scope.newDocketBatch.stage = 'error';
          $scope.newDocketBatch.loading = false;
        });
      }, function (err) {
        $scope.newDocketBatch.stage = 'error';
        $scope.newDocketBatch.loading = false;
      });
    }

    $scope.createBatchInvoice = function () {
      $scope.newDocketBatch.loading = true;
      /*if ( $scope.newDocketBatch.requiresXeroContactSync && $scope.newDocketBatch.customerContact ) {
        // sync with customer contact
        var contact = {id: $scope.newDocketBatch.customerContact.id, externalIdentifiers: {add:[{type:'xero', externalId: $scope.newDocketBatch.selectedXeroContact.externalId}]} };

        addressBookService.saveContact(contact, function(contactUpdated) {
          doInvoiceCreation();
        }, function(err) {
          $scope.newDocketBatch.loading = false;
          $scope.alertService.presentAutoAlert('');
        });
      } else*/ {
        doInvoiceCreation();
      }
    }

    // target: 'selection', xeroCustomerId: externalidentifier

    var doInvoiceCreation = function () {
      var postObj = { id: $scope.newDocketBatch.batchFull.id, type: $scope.newDocketBatch.invoiceType, target: 'customer', includeSupporting: $scope.newDocketBatch.attachPDFDockets };

      if ($scope.newDocketBatch.requiresXeroContactSync && $scope.newDocketBatch.selectedXeroContact) {
        postObj.target = 'selection'
        postObj.xeroCustomerId = $scope.newDocketBatch.selectedXeroContact.externalId
      }

      xeroService.createXeroInvoice(postObj, function (invoiceResponse) {
        if (invoiceResponse.localIdentifier) {
          $scope.newDocketBatch.loading = false;
          $scope.newDocketBatch.stage = 'success';
          $scope.newDocketBatch.batchFull = invoiceResponse;
        } else if (!invoiceResponse.jobId) {
          $scope.newDocketBatch.loading = false;
          $scope.newDocketBatch.stage = 'error';
        } else {
          checkForInvoiceCreationCompletion(invoiceResponse.jobId);
        }
      }, function (err) {
        $scope.newDocketBatch.loading = false;
        $scope.newDocketBatch.stage = 'error';
      });
    }

    var checkForInvoiceCreationCompletion = function (jobId) {
      $timeout(function () {
        userService.getTaskStatus(jobId, function (taskInfo) {
          if (taskInfo.status == 'Failed') {
            $scope.newDocketBatch.loading = false;
            $scope.newDocketBatch.stage = 'error';
            $scope.newDocketBatch.errorType = 'complex';
            $scope.newDocketBatch.displayComplexError = false;
            $scope.newDocketBatch.complexErrorMessage = taskInfo.eventLog;
          } else if (taskInfo.status != 'Complete') {
            checkForInvoiceCreationCompletion(jobId);
          } else {
            // get full batch to insert new InvoiceID
            batchService.getBatch($scope.newDocketBatch.batchFull.id, function (batchFull) {
              $scope.newDocketBatch.loading = false;
              $scope.newDocketBatch.stage = 'success';
              $scope.newDocketBatch.batchFull = batchFull;
            }, function (err) {
              $scope.newDocketBatch.loading = false;
              $scope.newDocketBatch.stage = 'error';
            });
          }
        }, function (err) {
        });
      }, 3000);
    }

    /*******************************/
    /***** Docket Data Helpers *****/
    /*******************************/

    $scope.invoiceSelectedDockets = function () {
      $scope.openDocketBatchModal($scope.selected);
      //$state.go('main.groupBatches', {orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, action:'newbatch', fromDocketsList:ids});
    }

    // Bulk Invoice Summary
    $scope.bulkSelectionSummary = function () {
      var ids = [];
      for (var i = 0; i < $scope.selected.length; i++) {
        ids.push($scope.selected[i].id);
      }

      ids = ids.join(',');

      var url = '/v1/organisations/' + $scope.currentOrg.id + '/groups/' + $scope.currentOrgGroup.id + '/dockets/downloadinvoicesummary?ids=' + ids;
      window.open(url, "_blank");
    }

    // Bulk Delete
    $scope.bulkSelectionDelete = function () {
      var itemsToDelete = $scope.selected;
      swal({
        title: "Are you sure?",
        text: "Do you really want to delete these " + itemsToDelete.length + " dockets?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          docketService.deleteBulkDockets(itemsToDelete, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('deleteBulkDockets', { status: 202, requestName: 'Delete bulk dockets - failures ' + failures.length + ' of ' + itemsToDelete.length });
              $scope.loadDocketsList();
            } else {
              $scope.alertService.presentAutoAlert('deleteBulkDockets', { status: 200 });
              $scope.loadDocketsList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    $scope.bulkSelectionSend = function () {
      var itemsToAct = $scope.selected;

      swal({
        title: "Are you sure?",
        text: "Do you really want to send these " + itemsToAct.length + " dockets?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, send them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          docketService.sendBulkDockets(itemsToAct, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('sendBulkDockets', { status: 202, requestName: 'Send bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length });
              $scope.loadDocketsList();
            } else {
              $scope.alertService.presentAutoAlert('sendBulkDockets', { status: 200 });
              $scope.loadDocketsList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    $scope.bulkSelectionReject = function () {
      $scope.rejectReason.text = '';
      $scope.bulkReject = true;
      $scope.rejectingDockets = $scope.selected.slice()
      if ($scope.rejectingDockets.length == 1) {
        $scope.rejectingDocket = $scope.rejectingDockets[0]
      }
      $("#rejectDocketModal").fadeIn(100);
    }

    $scope.bulkSelectionAccept = function () {
      var itemsToAct = $scope.selected;
      swal({
        title: "Are you sure?",
        text: "Do you really want to accept these " + itemsToAct.length + " dockets?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, accept them!",
        cancelButtonText: "No, cancel!",
        closeOnConfirm: true,
        closeOnCancel: true
      }, function (isConfirm) {
        if (isConfirm) {
          docketService.acceptBulkDockets(itemsToAct, function (failures) {
            if (failures && failures.length > 0) {
              $scope.alertService.presentAutoAlert('acceptBulkDockets', { status: 202, requestName: 'Accept bulk dockets - failures ' + failures.length + ' of ' + itemsToAct.length });
              $scope.loadDocketsList();
            } else {
              $scope.alertService.presentAutoAlert('acceptBulkDockets', { status: 200 });
              $scope.loadDocketsList();
            }
            $scope.selected = [];
          });
        }
      });
    }

    $scope.bulkSelectionExport = function () {
      var itemsToExport = [];
      for (var i = 0; i < $scope.selected.length; i++) {
        if ($scope.selected[i].id) {
          itemsToExport.push($scope.selected[i].id);
        }
      }

      var url = "/v1/organisations/" + $scope.currentOrg.id + "/groups/" + $scope.currentOrgGroup.id + "/dockets?export=true&ids=" + itemsToExport.join(',');
      window.open(url, "_blank");
    }

    /*******************/
    /***** Filters *****/
    /*******************/

    $scope.toggleFilters = function () {
      $scope.showFilters = !$scope.showFilters;
    }

    $scope.getFilterParams = function () {
      var params = {};
      params.timezone = moment.tz.guess();
      if ($scope.filters.startDate != null) {
        var fromDate = moment($scope.filters.startDate);
        params.fromDate = fromDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.endDate != null) {
        var toDate = moment($scope.filters.endDate);
        params.toDate = toDate.format('YYYY-MM-DD');
      }
      if ($scope.filters.status != 'All') {
        params.status = $scope.filters.status;
      }
      if ($scope.filters.fileStatusTab != 'all') {
        params.fileStatus = $scope.filters.fileStatusTab;
      }
      if ($scope.filters.customerGroup != null) {
        params.customerGroup = $scope.filters.customerGroup;
      }
      if ($scope.filters.supplierGroup != null) {
        params.supplierGroup = $scope.filters.supplierGroup;
      }
      if ($scope.filters.otherParty != 'All') {
        if ($scope.filters.otherParty.organisationGroup != null) {
          params.otherParty = $scope.filters.otherParty.organisationGroup;
        } else {
          var parsed = JSON.parse($scope.filters.otherParty);
          if (parsed.organisationGroup) {
            params.otherParty = parsed.organisationGroup;
          } else {
            params.otherParty = parsed.id;
          }
        }
      }
      if ($scope.filters.order != null && $scope.filters.order.id != null) {
        params.orderRef = $scope.filters.order.id;
      }
      if ($scope.filters.job != null && $scope.filters.job.id != null) {
        params.jobRef = $scope.filters.job.id;
      }
      if ($scope.filters.customerContact != null) {
        if ($scope.filters.customerContact.contactAddresses.length > 0) {
          var customerAddresses = [];
          for (var i = 0; i < $scope.filters.customerContact.contactAddresses.length; i++) {
            customerAddresses.push($scope.filters.customerContact.contactAddresses[i].emailAddress);
          }
          params.customer = customerAddresses.join(',');
        } else {
          params.customerDisplayName = $scope.filters.customerContact.displayName;
        }
      }
      if ($scope.filters.supplierContact != null) {
        var supplierAddresses = [];
        for (var i = 0; i < $scope.filters.supplierContact.contactAddresses.length; i++) {
          supplierAddresses.push($scope.filters.supplierContact.contactAddresses[i].emailAddress);
        }
        params.supplier = supplierAddresses.join(',');
      }
      if ($scope.filters.customerDisplayName != null) {
        params.customerDisplayName = $scope.filters.customerDisplayName;
      }
      if ($scope.filters.supplierDisplayName != null) {
        params.supplierDisplayName = $scope.filters.supplierDisplayName;
      }
      if ($scope.filters.customerSignatureName != null && $scope.filters.customerSignatureName != "") {
        params.customerSignatureName = $scope.filters.customerSignatureName;
      }
      if ($scope.filters.acceptedBy != null && $scope.filters.acceptedBy != "") {
        params.acceptedBy = $scope.filters.acceptedBy;
      }
      if ($scope.filters.docketNumber != null && $scope.filters.docketNumber != "") {
        params.docketNumber = $scope.filters.docketNumber;
      }
      if ($scope.filters.customerRefNo != null && $scope.filters.customerRefNo != "") {
        params.customerRefNo = $scope.filters.customerRefNo;
      }
      if ($scope.filters.supplierRefNo != null && $scope.filters.supplierRefNo != "") {
        params.supplierRefNo = $scope.filters.supplierRefNo;
      }
      if ($scope.filters.author != null && $scope.filters.author != "") {
        params.authorName = $scope.filters.author;
      }

      return params;
    }

    $scope.clearFilterDateSet = function (field1, field2) {
      $scope.filters[field1] = null;
      $scope.filters[field2] = null;
    }

    $scope.searchDocketsChange = function (value) {
      $scope.loadDocketsList(value);
    }

    $scope.clearFilterItem = function (name) {
      $scope.filters[name] = null;
      $scope.filtersChanged(name);
    }

    $scope.clearCustomFilterItem = function (customItem) {
      customItem.value = ''
      customItem.display = false
      $scope.filtersChanged(customItem.fieldName)
    }

    $scope.clearFilters = function () {
      $scope.filters.order = null;
      $scope.filters.job = null;
      $scope.filters.customerContact = null;
      $scope.filters.supplierContact = null;
      $scope.filters.customerDisplayName = null;
      $scope.filters.supplierDisplayName = null;
      $scope.filters.customerSignatureName = null;
      $scope.filters.acceptedBy = null;
      $scope.filters.docketNumber = null;
      $scope.filters.customerRefNo = null;
      $scope.filters.supplierRefNo = null;
      $scope.filters.author = null;
      $scope.filters.custom =
        $scope.currentOrg && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.customColumns
          ? $scope.currentOrg.features.dockets.customColumns.map(fieldName => ({ fieldName, prettyName: fieldName.match(/[A-Z][a-z,1-9]+/g).join(' '), display: false, value: '' }))
          : []
      for (var i in statusFilterOptions) {
        $scope.filters.statusOptions[statusFilterOptions[i]] = true;
      }
      $scope.filters.statusOptions.allView = true;
      $scope.filters.statusOptions.all = true;
      // reset date filters
      $scope.filters.startDate = moment().subtract(7, 'days').toDate(); //startFromDate
      $scope.filters.endDate = moment().toDate(); //endToDate
      $scope.dateFilterModel.dateStart = moment().subtract(7, 'days').toDate();
      $scope.dateFilterModel.dateEnd = moment().toDate();
      $scope.filtersChanged('cleared');
      window.location.reload();
    }

    $scope.resetAllFilters = function () {
      // SETUP filters
      $scope.filters = {};
      $scope.filters.otherParty = "All";
      $scope.filters.statusTab = "All";
      $scope.filters.status = 'All';
      $scope.filters.fileStatusTab = 'all';
      $scope.filters.batchStatusTab = 'all';
      $scope.filters.organisation = 'All';
      $scope.filters.startDate = null;
      $scope.filters.endDate = null;
      $scope.filters.customerGroup = null;
      $scope.filters.docketNumber = null;
      $scope.filters.customerRefNo = null;
      $scope.filters.supplierRefNo = null;
      $scope.filters.author = null;
      $scope.filters.supplierGroup = null;
      $scope.filters.customerDisplayName = null;
      $scope.filters.supplierDisplayName = null;
      $scope.filters.customerSignatureName = null;
      $scope.filters.custom =
        $scope.currentOrg && $scope.currentOrg.features.dockets && $scope.currentOrg.features.dockets.customColumns
          ? $scope.currentOrg.features.dockets.customColumns.map(fieldName => ({ fieldName, prettyName: fieldName.match(/[A-Z][a-z,1-9]+/g).join(' '), display: false, value: '' }))
          : []
      $scope.filters.acceptedBy = null;
    }

    $scope.setComplexFilter = function (filterName) {
      if (filterName == 'sentDockets') {
        $scope.filters.statusTab = "Sent";
        $scope.filters.status = "Sent";
        if ($scope.currentOrgGroup) {
          $scope.filters.supplierGroup = $scope.currentOrgGroup.id;
        } else {
          $scope.filters.supplierGroup = null;
        }
        $scope.filters.customerGroup = null;
      } else if (filterName == 'recievedDockets') {
        $scope.filters.statusTab = "Recieved";
        $scope.filters.status = "Sent";
        if ($scope.currentOrgGroup != null) {
          $scope.filters.customerGroup = $scope.currentOrgGroup.id;
        } else {
          $scope.filters.customerGroup = null;
        }
        $scope.filters.supplierGroup = null;
      } else if (filterName == 'draftDockets') {
        $scope.filters.statusTab = "Draft";
        $scope.filters.status = "Draft";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      } else if (filterName == 'acceptedDockets') {
        $scope.filters.statusTab = "Accepted";
        $scope.filters.status = "Accepted";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      } else if (filterName == 'rejectedDockets') {
        $scope.filters.statusTab = "Rejected";
        $scope.filters.status = "Rejected";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      } else if (filterName == 'allDockets') {
        $scope.filters.statusTab = "All";
        $scope.filters.status = "All";
        $scope.filters.customerGroup = null;
        $scope.filters.supplierGroup = null;
      }
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /*****************************/
    /***** Date/Time Pickers *****/
    /*****************************/

    $scope.selectDate = function (dateObject, field, ev) {
      $mdpDatePicker(dateObject[field], {
        targetEvent: ev
      }).then(function (selectedDate) {
        dateObject[field] = selectedDate;
      });
    }

    $scope.showDatePicker = function (field, ev) {
      $mdpDatePicker($scope.itemEdit[field], {
        targetEvent: ev
      }).then(function (selectedDate) {
        $scope.itemEdit[field] = selectedDate;
      });
    }

    $scope.showTimePicker = function (field, ev) {
      $mdpTimePicker($scope.itemEdit[field], {
        targetEvent: ev,
        autoSwitch: true
      }).then(function (selectedTime) {
        $scope.itemEdit[field] = selectedTime;
      });
    }

    /***********************************/
    /***** Last geolocation helper *****/
    /***********************************/

    var timeoutPromise = null;

    $scope.updateGeolocation = function (firstTime) {
      var getLocation = false;
      var minutesElapsed = moment.duration(moment().diff($scope.lastGeolocationCheck)).asMinutes();
      if (minutesElapsed > 2 || firstTime == true) {
        getLocation = true;
      } else {
        getLocation = false;
      }
      if (getLocation) {
        navigator.geolocation.getCurrentPosition(function (data) {
          $scope.lastGeolocation = { lat: data.coords.latitude, long: data.coords.longitude, time: moment() };
          $scope.lastGeolocationCheck = moment();
          timeoutPromise = $timeout(function () {
            $scope.updateGeolocation();
          }, 10000);
        }, function (err) {
          $scope.lastGeolocationCheck = moment();
          timeoutPromise = $timeout(function () {
            $scope.updateGeolocation();
          }, 10000);
        });
      } else {
        timeoutPromise = $timeout(function () {
          $scope.updateGeolocation();
        }, 10000);
      }
    }

    $scope.updateGeolocation(true);

    $scope.$on('$destroy', function () {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    });


    // Load dockets list after child controller is ready
    $scope.docketsChildControllerReady = function () {
      if ($scope.listView == 'dockets') {
        // check stateParams for any filter presets
        if ($scope.currentOrg && sessionStorage.getItem('docketsList') != undefined) {
          // check if last stored orders filters is the same as current filters
          var lastDocketsFilters = {};
          if (sessionStorage.getItem('docketsLastFilters')) {
            lastDocketsFilters = JSON.parse(sessionStorage.getItem('docketsLastFilters'));
          }
          var loadNew = false;
          if (sessionStorage.getItem('filters')) {
            var storedFilters = JSON.parse(sessionStorage.getItem('filters'));
            if (storedFilters.reloadRequired == true) {
              loadNew = true;
              $scope.filters.reloadRequired = false;
            }
          }
          if (lastDocketsFilters && lastDocketsFilters != undefined) {
            if (lastDocketsFilters.organisationId != $scope.currentOrg.id || lastDocketsFilters.groupId != $scope.currentOrgGroup.id) {
              loadNew = true;
              $scope.filters.job = null;
              $scope.filters.order = null;
            }
            if (lastDocketsFilters.startDate && moment(lastDocketsFilters.startDate).diff(moment($scope.filters.startDate), 'days') != 0) {
              loadNew = true;
            } else if (lastDocketsFilters.endDate && moment(lastDocketsFilters.endDate).diff(moment($scope.filters.endDate), 'days') != 0) {
              loadNew = true;
            }
            // check if status options have changed
            if (lastDocketsFilters.statusOptions.all == true && $scope.filters.statusOptions.all != true) {
              loadNew = true;
            } else {
              for (var i = 0; i < statusFilterOptions.length; i++) {
                if (lastDocketsFilters.statusOptions[statusFilterOptions[i]] != $scope.filters.statusOptions[statusFilterOptions[i]]) {
                  loadNew = true;
                }
              }
            }
            if (lastDocketsFilters.customerSignatureOptions) {
              $scope.filters.customerSignatureOptions = lastDocketsFilters.customerSignatureOptions;
            }
            if (lastDocketsFilters.filedOptions) {
              $scope.filters.filedOptions = lastDocketsFilters.filedOptions;
            }
            if (lastDocketsFilters.customerContact && !$scope.filters.customerContact) {
              loadNew = true;
            } else if (!lastDocketsFilters.customerContact && $scope.filters.customerContact) {
              loadNew = true;
            } else if (!lastDocketsFilters.customerContact && !$scope.filters.customerContact) {
              // do nothing
            } else if (lastDocketsFilters.customerContact.id != $scope.filters.customerContact.id) {
              loadNew = true;
            }
            if (lastDocketsFilters.supplierContact && !$scope.filters.supplierContact) {
              loadNew = true;
            } else if (!lastDocketsFilters.supplierContact && $scope.filters.supplierContact) {
              loadNew = true;
            } else if (!lastDocketsFilters.supplierContact && !$scope.filters.supplierContact) {
              // do nothing
            } else if (lastDocketsFilters.supplierContact.id != $scope.filters.supplierContact.id) {
              loadNew = true;
            }
            if (lastDocketsFilters.supplierDisplayName != $scope.filters.supplierDisplayName) {
              loadNew = true;
            }
            if (lastDocketsFilters.customerSignatureName != $scope.filters.customerSignatureName) {
              loadNew = true;
            }
            /*if ( _.difference(lastDocketsFilters.custom, $scope.filters.custom).length > 0 ) {
              loadNew = true
            }*/
            if (lastDocketsFilters.acceptedBy != $scope.filters.acceptedBy) {
              loadNew = true;
            }
            if (lastDocketsFilters.customerDisplayName != $scope.filters.customerDisplayName) {
              loadNew = true;
            }
          } else {
            // no previous filters stored, load new list
            loadNew = true;
          }
          // check if order filter has changed
          if (lastDocketsFilters.order && !$scope.filters.order) {
            loadNew = true;
          } else if (!lastDocketsFilters.order && $scope.filters.order) {
            loadNew = true;
          } else if (!lastDocketsFilters.order && !$scope.filters.order) {
            // do nothing
          } else if (lastDocketsFilters.order.id != $scope.filters.order.id) {
            loadNew = true;
          }
          // check if job filter has changed
          if (lastDocketsFilters.job && !$scope.filters.job) {
            loadNew = true;
          } else if (!lastDocketsFilters.job && $scope.filters.job) {
            loadNew = true;
          } else if (!lastDocketsFilters.job && !$scope.filters.job) {
            // do nothing
          } else if (lastDocketsFilters.job.id != $scope.filters.job.id) {
            loadNew = true;
          }

          if (loadNew) {
            $scope.filters.query.page = 1;
            $scope.loadDocketsList();
          } else {
            var docketsListParsed = JSON.parse(sessionStorage.getItem('docketsList'));
            var docketsListCount = JSON.parse(sessionStorage.getItem('docketsListCount'));
            $scope.loadDocketsListFromParent(docketsListParsed, docketsListCount);
            if ($scope.currentOrg != null) {
              $scope.loadDocketsListFiledStatus(docketsListParsed);
            }
            $scope.preventReloadWithFilters = false;
          }
        } else {
          $scope.loadDocketsList();
        }
      }
    }

    $scope.showUpgradePlanModal = function (_, feature, trackingText) {
      $scope.selectPlan(null, feature, trackingText)
    }
  });



// WEBPACK FOOTER //
// ./src/controllers/dockets/desktopController.js